import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import Image from 'react-image-resizer';
import * as CookieService from '../CookieService';
import * as FavItemMainAction from '../actions/FavItemMainAction';
import FavItemMainStore from '../stores/FavItemMainStore';
import * as MenuAction from '../actions/MenuAction';
import * as $ from 'jquery';
import SDIConstants from '../SDIConstants';
import ReactPaginate from 'react-paginate';
import { withTranslation, Trans } from 'react-i18next'
//[2/16/22], WW-330, Dhevanesam R
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
/*[03/20/22,PC_01,WW-373], Priyanka D */
import NonCatalogStore from '../stores/NonCatalogStore';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import MultiSelect from "react-multi-select-component";
import Select from 'react-select'
import Autocomplete from 'react-autocomplete'; //WW-368_SuggestionCat_for_favItem_PC_03
import ShowMoreText from "react-show-more-text";
import swal from 'sweetalert';
import AlternatepartsComponent from '../components/AltPartDetails';
import QuickItemComponent from '../components/QuickItemComponent';
//import QrReader from 'react-qr-scanner'
let searchTxt = "";
let searchCol = "ALL";
let isPostBack = true;
/*[03/20/22,PC_01,WW-373], Priyanka D */
let rmvAttachindex = -1;
let currentPagePath;
let cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]

const previewStyle = {
    height: '240px',
    width: '320px',
}
const style = {
    image: {
        //  position: 'sticky !important',
        display: 'block',
        left: '0px !important',
        top: '0px !important',
        // marginLeft: '40px',
        cursor: 'pointer',
        position: 'auto !important',
        margin: '0px 0px',
        // justifyContent: 'flex-end'
    },
}
class FavItemMainComponent extends Component {
    constructor(props) {
        super(props);
        this.addedtoCart = this.addedtoCart.bind(this);
        this.AnykeyPress = this.AnykeyPress.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.InsertNewFavItem = this.InsertNewFavItem.bind(this);
        this.UpdateFavItembind = this.UpdateFavItembind.bind(this);
        this.DelFavItem = this.DelFavItem.bind(this);
        this.AssignNewFavItem = this.AssignNewFavItem.bind(this);
        this.showitemdetails = this.showitemdetails.bind(this);
        // this.DelFavItem = this.DelFavItem.bind(this);
        this.UpdateFavItembind = this.UpdateFavItembind.bind(this);
        this.addedtoCart = this.addedtoCart.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
        this.loadAttachments = this.loadAttachments.bind(this);
        this.warehouseqtyresponse = this.warehouseqtyresponse.bind(this);
        this.removeAttachmentResponse = this.removeAttachmentResponse.bind(this);
        this.ShareItemButtonClickResponse = this.ShareItemButtonClickResponse.bind(this);
        this.AssignFavItemData = this.AssignFavItemData.bind(this);
        this.DeleteMultipleItemResponse = this.DeleteMultipleItemResponse.bind(this);
        this.handleScan = this.handleScan.bind(this)
        this.state = {
            GridArr: [], NewItem: [], yourCat: "", yourDes: "", Response: [], RemainItemId: "", filterDisplayName: "All", isFavorited: false, AltItems: [], FlagTable: [], FilteredFlagTable: [],
            PageNo: 1, isPageLoad: false,
            RecCount: 10, totalCount: 0, pageCount: 0, itemQuantity: [], id: [],
            SortingType: "DESC",
            SortingColumn: "ADD_DTTM", searchDisplayName: "All", FromDate: "", ToDate: "", delMFG: "", delMFGpart: "", delSupp: "", attachmentPathArr: [],/*[03/20/22,PC_01,WW-373], Priyanka D */
            UserDD: [], SelectedUser: [], RegionDD: [], SelectedRegion: [], EMPDD: [], SharedItem: {}, CategoryShare: false, CategoryArr: [], autocompleteData: [], autocompleteDataRstl: [],//WAL-714 WW-368_SuggestionCat_for_favItem
            multiDelete: false, SelectAll: true, SortingVal: "DESC",//WW-419_PC-01 (5/25/2022) -Aparna
            delay: 100,
            result: 'No result', QR: false, CategoryErr: false, IskitCoreDisplay: false, RemainObj: {}, SelectedCategory: "", SelectedCatIndex: "", SubCategoryArr: [], FavSubCategory: "", subCategoryResults: [], subCategory: [], SubCategoryErr: false, AddValue: [], rowindex: 0,
            IsDotClickIndex: [], /*18/10/23, PC_WW_850_05, Vishwa S]*/
            itemsAddedToCart: {},  // To keep track of items added to the cart
            cartConfirmationPopupTxt: "", // [12/06/2024, WW-1221 Preventive work order -Vishwa S]
            addItemMessage: null,  // to track what message to show in swal
        }
        cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    }
    componentDidMount() {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        //console.log("window", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        FavItemMainAction.getCurrentFavPage(getFavPageBO);
        isPostBack = true;
        searchTxt = "";
        searchCol = "ALL";
        this.favPageLoad("1", this.state.RecCount, searchTxt, searchCol, "ADD_DTTM", "DESC");
        FavItemMainStore.on('favItemload', this.AssignFavItemData);
        FavItemMainStore.on('NewfavItem', this.AssignNewFavItem);
        FavItemMainStore.on('InsertfavItem', this.InsertNewFavItem);
        FavItemMainStore.on('DeleteItem', this.DelFavItem);
        FavItemMainStore.on('UpdateFavItem', this.UpdateFavItembind);
        FavItemMainStore.on('addedtoCart', this.addedtoCart);
        FavItemMainStore.on('favpage', this.loadFavPageResponse);
        FavItemMainStore.on('updateFavPage', this.updateFavPageResponse);
        //[2/16/22], WW-330, Dhevanesam R
        ShoppingCartStore.on('Warehousecheck', this.warehouseqtyresponse);
        NonCatalogStore.on('attachmentResponse', this.loadAttachments);
        NonCatalogStore.on('rmvAttach', this.removeAttachmentResponse);
        //WAL-714
        FavItemMainStore.on('ShareItem', this.ShareItemButtonClickResponse);
        FavItemMainStore.on('MultiDelete', this.DeleteMultipleItemResponse); //WW-419_PC_09 (5/25/2022) -Aparna

    }
    handleScan(data) {
        this.setState({
            result: data,
        })
        //console.error("QRSCANNER", data);
    }
    handleError(err) {
        console.error(err)
    }
    webcamaccess = () => {
        this.setState({ QR: this.state.QR == true ? false : true });
    }
    addedtoCart = () => {
        let AltItems = [];
        let FilteredFlagTable = [];
        //[1/20/23, WW-542_PC_19, Dhevanesam R]
        let srtxt = ""
        if (searchTxt != "") {
            srtxt = $(`#searchTxt`).val().toLowerCase();
        }
        //[06/20/22,PC_01], Pavithra R getting the response an checking with condition
        let AddItem = JSON.parse(FavItemMainStore.PageLoadData);
        let FlagTable = AddItem.FlagTable
        let AlternatePartdetail = AddItem.AltPartDetails
        let AlternatePartdetailFlag = AddItem.AltPartDetailsFlag
        MenuAction.refreshMasterData();
        let Avilable_items = FlagTable.filter((x) => x.is_Success == "True")
        if (Avilable_items.length > 0) {
            if (this.state.addItemMessage) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: this.state.addItemMessage
                });
                this.setState({ addItemMessage: null });
            }

            if (Avilable_items.length == 1) {
                this.favPageLoad("1", this.state.RecCount, srtxt, searchCol, "ISA_FAVS_CATEGORY", this.state.SortingVal)
                return;
            } else if (Avilable_items.length > 0) {
                this.favPageLoad("1", this.state.RecCount, srtxt, searchCol, "ISA_FAVS_CATEGORY", this.state.SortingVal)
                return;

            }
        }
        else {
            if (AlternatePartdetail != undefined && AlternatePartdetail != null && AlternatePartdetail != "") {
                if (AlternatePartdetail.length > 0) {
                    AltItems = AlternatePartdetail.filter((x) => x.AlternateItemID == FlagTable[0].Item_ID + "|")
                } else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + FlagTable[0].Item_ID + " is not available in catalog"
                    });
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    return;
                }
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Item " + FlagTable[0].Item_ID + " is not available in catalog"
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');

            }
            // WW-685 PC_685_03 Display label for unavaialable item 5/26/2023 Pavithra R
            let { GridArr } = this.state;
            //  let griddata = this.state.GridArr;
            GridArr.forEach((value, index) => {
                let alpartFlag = AlternatePartdetailFlag.filter(x => (value.CLIENT_MFG_PART.toUpperCase() == x.MFGPartNum.toUpperCase() && value.ISA_CP_ITEM_ID.toUpperCase() == x.ItemID.toUpperCase() && value.MANUFACTURER.toUpperCase() == x.Manufacturer.toUpperCase() && value.SUPPLIER_ID == x.SupplierID))
                if (alpartFlag.length > 0) {
                    GridArr[index].ISA_CATALOG_FLAG = AlternatePartdetailFlag[0].Isa_Catalog_Flag;
                    GridArr[index].ISA_COMMENTS = AlternatePartdetailFlag[0].ISA_COMMENTS; //PC_WAL-1100_06-Adding a column-comments

                }
            })
            this.setState(GridArr);

            // return
        }


        if (!AltItems.length > 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Item " + FlagTable[0].Item_ID + " is not available in catalog"
            });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return;

        } else {
            FilteredFlagTable = FlagTable.filter((x) => x.is_Success == "False")
            FilteredFlagTable.map((val, index) => {
                val.startIndex = 0
            });
            AltItems.map((val, index) => {
                val.IsSelected = false
                val.QuantityOrdered = val.min_order_qty;
            });
            this.setState({ AltItems: AltItems, FlagTable: FlagTable, FilteredFlagTable: FilteredFlagTable })
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#AltItems').modal('show');
        }

    }


    componentWillUnmount() {
        $('#AltItems').modal('hide');
        FavItemMainStore.removeListener('favItemload', this.AssignFavItemData);
        FavItemMainStore.removeListener('NewfavItem', this.AssignNewFavItem);
        FavItemMainStore.removeListener('InsertfavItem', this.InsertNewFavItem);
        FavItemMainStore.removeListener('DeleteItem', this.DelFavItem);
        FavItemMainStore.removeListener('UpdateFavItem', this.UpdateFavItembind);
        FavItemMainStore.removeListener('addedtoCart', this.addedtoCart);
        //[2/16/22], WW-330, Dhevanesam R
        ShoppingCartStore.removeListener('Warehousecheck', this.warehouseqtyresponse);
        NonCatalogStore.removeListener('attachmentResponse', this.loadAttachments);
        //WAL-714
        FavItemMainStore.removeListener('ShareItem', this.ShareItemButtonClickResponse);
        FavItemMainStore.removeListener('MultiDelete', this.DeleteMultipleItemResponse);
    }
    closePopup = (message) => {
        $('#AltItems').modal('hide');
        if (message != "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: message
            });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    };
    /*[03/20/22,PC_05,WW-373], Priyanka D */
    loadAttachments = () => {
       
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            /*[03/23/22,PC_32,WAL-511], Priyanka D */
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "You can choose only the Image files!!"
                });
                //  alert("You can choose only the Image files!!")
                return;
            }
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    /*[03/20/22,PC_07,WW-373], Priyanka D */
    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            document.getElementById("lblerror").innerText = "";
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments.splice(rmvAttachindex, 1);
            this.setState({ attachmentPathArr: tempAttachments });
            rmvAttachindex = -1;
        }
    };
    /*[03/20/22,PC_04,WW-373], Priyanka D */
    bindAttachments = () => {
        return this.state.attachmentPathArr.map((attachment, index) => {
            return (
                <div className="attachment-file-name mt-2" key={index}>
                    <a className="Attachment-overflow  col-4 p-0" data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                    <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index)}>X</span>
                </div>

            );
        });
    };
    /*[03/20/22,PC_08,WW-373], Priyanka D */
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };
    /**
     * Ref: NC_PC_13
     * On click method of removing attachments
     * @param filepath
     * @param index
     */
    /*[03/20/22,PC_06,WW-373], Priyanka D */
    removeAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachment(removeBO);
    }


    favPageLoad = (pg, RecCount, searchText, searchColumn, sortColumn, sortValue) => {
        let favItemBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            pageNo: pg,
            itemCount: RecCount, searchText: searchText, searchColumn: searchColumn, sortColumn: sortColumn, sortValue: sortValue,
            Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
            ThirdParty_CompanyID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"),
            IsWeb: true

        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        FavItemMainAction.FavItemPageLoad(favItemBO);
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(FavItemMainStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (FavItemMainStore.updateFavPageResponse.updateType == 1) {

            let response = JSON.parse(FavItemMainStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }

        } else {
            let response = JSON.parse(FavItemMainStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        isPostBack = false;
        //this.refreshMenu();
        MenuAction.refreshMasterData()
    };

    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true//isFirstTimeLoaded
        };
        console.log("masterBO", masterBO);
        MenuAction.getMasterData(masterBO);
    };
    //[2/16/22], WW-330, Dhevanesam R
    AssignFavItemData = () => {

        let checkqty = false
        let PageLoadResponse = JSON.parse(FavItemMainStore.PageLoadData);
        let response = PageLoadResponse.FavItemData;
        PageLoadResponse.FavItemData.forEach((value, index) => {
            value.QTY_REQUESTED = "";
            value.checked = false;
            value.SubCatcheck = false;
            //WW-368_PC_ 
            if (value.ISA_FAVS_CATEGORY == " " || value.ISA_FAVS_CATEGORY == "" || value.ISA_FAVS_CATEGORY == null || value.ISA_FAVS_CATEGORY == undefined) {
                value.ISA_FAVS_CATEGORY = "UNCLASSIFIED"
            }
            if (value.ISA_FAVS_SUBCATEGORY == " " || value.ISA_FAVS_SUBCATEGORY == "" || value.ISA_FAVS_SUBCATEGORY == null || value.ISA_FAVS_SUBCATEGORY == undefined) {
                value.ISA_FAVS_SUBCATEGORY = "UNCLASSIFIED"
            }
        });
    
        PageLoadResponse.FavItemData.forEach((value, index) => {
            value.hasBenItemVal = "";
            value.InvItemQtyCheck = false
        });
        console.log("sample", PageLoadResponse.FavItemData)
     
        //Removed the condition check for Storevalue-WW-330-Priyanka D
        //if (localStorage.getItem("StoreValue") != undefined || localStorage.getItem("StoreValue") != null) {
        //BenStoreVal = JSON.parse(localStorage.getItem("StoreValue"));
        let warehouse_item = PageLoadResponse.FavItemData.filter((x) => x.SUPPLIER_ID == "W999999999")
        let loacalloc = JSON.parse(localStorage.getItem("StoreValue"))

        if (warehouse_item.length > 0) {
            checkqty = true;
        }
        if (checkqty) {
            let itemids = []
            warehouse_item.map((val, index) => {

                itemids.push(val.ISA_CP_ITEM_ID)
            });
            if (itemids.length > 0) {
               
                let BO = {
                    shipto_id: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",//loacalloc, WAL-767 -Aparna
                    supplier_part_number: itemids,
                    User_Id: CookieService.getLocalStorageValues("Session_UserID")
                }
               
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ShoppingCartAction.WarehouseQTYCheck(BO)
            }

        }
        // }
        //WAL-541_PC_16 -Aparna
        let category = []
        if (response != undefined) {
            category = response.filter((v, i, a) => a.findIndex(t => (t.ISA_FAVS_CATEGORY === v.ISA_FAVS_CATEGORY)) === i)
            console.log("cattttt", category)
            //tot = category.length
        }
        let countT = parseFloat(category.length) / 10
        //WAL-714_PC_16 update
        let catpush = []
        if (category != undefined) {
            category.forEach((value, index) => {
                if (value.ISA_FAVS_CATEGORY == " " || value.ISA_FAVS_CATEGORY == "" || value.ISA_FAVS_CATEGORY == null || value.ISA_FAVS_CATEGORY == undefined) {
                    value.ISA_FAVS_CATEGORY = "UNCLASSIFIED"
                }
                value.check = false;
            });
        }
        console.log("PageLoadResponse.FavItemData", PageLoadResponse.FavItemData)
        console.log("PageLoadResponse.FavItemData", category)
        //WW-368_SuggestionCat_for_favItem_PC_ -Aparna
        let autoCompleteDataRes = []
        let suggestionsStr = CookieService.getLocalStorageValues("Fav_Item_Cat")
        if (suggestionsStr != null && suggestionsStr != "" && suggestionsStr != undefined) {
            suggestionsStr.forEach((sugg, index) => {
                autoCompleteDataRes.push({ label: sugg.ISA_FAVS_CATEGORY, value: sugg.ISA_FAVS_CATEGORY });
            });
            autoCompleteDataRes = autoCompleteDataRes.sort((a, b) =>
                a.value > b.value ? 1 : -1,
            );
        }
        let locSubCat = []
        let locSubCatSGG = []
        let subcatsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
        console.log("Fav_Item_SubCat", subcatsuggestion)
        console.log("Fav_Item_Cat -fav", suggestionsStr)
        const isDuplicate = false
        if (subcatsuggestion != null && subcatsuggestion != "" && subcatsuggestion != undefined) {
            subcatsuggestion.forEach((sugg, index) => {
                //WW-516_PC_04  (9/30/2022)-Aparna
                if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                    //if (locSubCat.length > 0) {
                    //    isDuplicate = locSubCat.label.includes(sugg.ISA_FAVS_SUBCATEGORY);
                    //}
                    // const isDuplicate = locSubCat.label.includes(sugg.ISA_FAVS_SUBCATEGORY);
                    //  if (!isDuplicate) {
                    locSubCat.push({ label: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), value: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), category: sugg.ISA_FAVS_CATEGORY.toUpperCase() });


                    // }

                }

            });
        }
        if (locSubCat.length > 0) {
            locSubCatSGG = locSubCat.filter((v, i, a) => a.findIndex(t => (t.value === v.value && t.category === v.category && t.value != null && t.value != " ")) === i)
            locSubCatSGG = locSubCatSGG.sort((a, b) =>
                a.value > b.value ? 1 : -1,
            );
            //locSubCatSGG = locSubCat.filter((item,
            //    index) => locSubCat.indexOf(item.value) === index);

        }
        console.log("locSubCatSGG", locSubCatSGG)
        //[1/3/23], WW-542_PC_12, Dhevanesam R
        //subcatsuggestion = subcatsuggestion.sort((a, b) => (a.ADD_DTTM > b.ADD_DTTM ? -1 : 1))
        //[1/5/23, WW-542_PC_14, Dhevanesam R]
        if (PageLoadResponse.FavItemData != null && PageLoadResponse.FavItemData != undefined) {
            PageLoadResponse.FavItemData = PageLoadResponse.FavItemData.sort((a, b) => (a.ADD_DTTM > b.ADD_DTTM ? -1 : 1))
        }
        if ($(`#searchTxt`).val() == "" || $(`#searchTxt`).val() == null || $(`#searchTxt`).val() == undefined) {
            if (PageLoadResponse.FavItemData != null && PageLoadResponse.FavItemData != undefined && PageLoadResponse.FavItemData.length != 0 && category != null && category != undefined && category.length != 0) {
                category = PageLoadResponse.FavItemData.filter((v, i, a) => a.findIndex(t => (t.ISA_FAVS_CATEGORY === v.ISA_FAVS_CATEGORY)) === i)
            }
        }
        else {
            let catFilter = []
            if (PageLoadResponse.FavItemData != null && PageLoadResponse.FavItemData != undefined && PageLoadResponse.FavItemData.length != 0 && category != null && category != undefined && category.length != 0) {
                PageLoadResponse.FavItemData.forEach((value, index) => {
                    category.forEach((resVal, resIndex) => {
                        if (value.ISA_FAVS_CATEGORY == resVal.ISA_FAVS_CATEGORY && value.ISA_FAVS_SUBCATEGORY == resVal.ISA_FAVS_SUBCATEGORY) {
                            catFilter.push(value);
                        }
                    });
                })
            }
            catFilter = catFilter.sort((a, b) => (a.ADD_DTTM > b.ADD_DTTM ? -1 : 1))
            category = catFilter.filter((v, i, a) => a.findIndex(t => (t.ISA_FAVS_CATEGORY === v.ISA_FAVS_CATEGORY && t.ISA_FAVS_SUBCATEGORY == v.ISA_FAVS_SUBCATEGORY)) === i)
        }
        let count = 0;
        if (PageLoadResponse.TotalCount.length > 0) {
            count = PageLoadResponse.TotalCount[0].TOTALCOUNT;
        }

        this.setState({
            GridArr: PageLoadResponse.FavItemData, totalCount: count, isPageLoad: true, CategoryArr: category, autocompleteData: autoCompleteDataRes, subCategory: locSubCatSGG,
            subCategoryResults: [], autocompleteDataRstl: autoCompleteDataRes, FavSubCategory: ""
        }); //WAL-714 update WW-368_SuggestionCat_for_favItem
        console.log("autocompleteData", CookieService.getLocalStorageValues("Fav_Item_Cat"))

        let pg = Math.ceil((count > 0 ? count : 0) / this.state.RecCount);
        //WAL-714_PC_03 -Aparna
        let locEMP = []
        let locREGDD = []
        let locReg = []
        if (PageLoadResponse.EmployeeCC != undefined && PageLoadResponse.EmployeeCC != null) {

            if (PageLoadResponse.EmployeeCC.length > 0) {
                PageLoadResponse.EmployeeCC.map((val, index) => {
                    if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                        let localArray = {
                            value: val.EMP_ID,
                            label: val.ISA_EMPLOYEE_NAME + " " + val.ISA_EMPLOYEE_EMAIL
                        }

                        locEMP.push(localArray)
                    }

                });
                locReg = PageLoadResponse.EmployeeCC.filter((v, i, a) => a.findIndex(t => (t.REGION === v.REGION && t.REGION != null && t.REGION != " ")) === i)
                locReg.map((val, index) => {
                    let localArray = {
                        value: val.REGION,
                        label: val.REGION
                    }

                    locREGDD.push(localArray)
                });

            }

        }
        this.setState({
            pageCount: countT, totalCount: count, UserDD: locEMP, RegionDD: locREGDD, EMPDD: PageLoadResponse.EmployeeCC
        }); //WAL-541_PC_16 -Aparna WAL-714
        //WW-516_FI_PC_06 (10/14/2022)-Aparna
        //WW-757 Share Optimization A1QA bUG FIX (8/1/2023)-Pavithra R
        let locSelectedCat = "";
        let locSelectedCatIndex = 0;
        let categoryLength = category.length;
        let searctxt = $(`#searchTxt`).val()
        if (searctxt != undefined) {
            searctxt = searctxt.toLowerCase()
        }
        if (searctxt == "") {
            if (this.state.SelectedCatIndex != 0 && this.state.SelectedCatIndex != "") {
                locSelectedCatIndex = this.state.SelectedCatIndex
                if (categoryLength == locSelectedCatIndex) {
                    locSelectedCat = category[0]
                    locSelectedCatIndex = 0;
                }
                else {
                    locSelectedCat = category[locSelectedCatIndex]
                }
            }
            else {
                if (CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != null && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != "" && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != undefined && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != " " && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != 0 && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != "0") {

                    locSelectedCatIndex = CookieService.getLocalStorageValues("SelectedCatIndexFavItem")

                    if (categoryLength == locSelectedCatIndex) {
                        locSelectedCat = category[0]
                        locSelectedCatIndex = 0;
                        CookieService.updateLocalStorageValues("SelectedCatIndexFavItem", "");
                    }
                    else {
                        locSelectedCat = category[locSelectedCatIndex]
                        CookieService.updateLocalStorageValues("SelectedCatIndexFavItem", "");

                    }
                }
                else {
                    locSelectedCatIndex = 0
                    locSelectedCat = category[0]
                }
            }
        }
        else {
            if (CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != null && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != "" && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != undefined && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != " " && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != 0 && CookieService.getLocalStorageValues("SelectedCatIndexFavItem") != "0") {
                locSelectedCatIndex = CookieService.getLocalStorageValues("SelectedCatIndexFavItem")
                if (categoryLength == locSelectedCatIndex) {
                    locSelectedCat = category[0]
                    locSelectedCatIndex = 0;
                    CookieService.updateLocalStorageValues("SelectedCatIndexFavItem", "");
                }
                else {
                    locSelectedCat = category[locSelectedCatIndex]
                    CookieService.updateLocalStorageValues("SelectedCatIndexFavItem", "");
                }
            }
            else {
                locSelectedCatIndex = 0
                locSelectedCat = category[0]
            }
        }
        console.log("locSelectedCat", locSelectedCat)
        console.log("locSelectedCatIndex", locSelectedCatIndex)
        //WW-542_PC_05 (12/1/2022) -Aparna
        let locmenuFavItemCategory = CookieService.getLocalStorageValues("menuFavItemCategory");

        if (locmenuFavItemCategory != null && locmenuFavItemCategory != undefined && locmenuFavItemCategory != "") {
            console.log("menu- click category", locmenuFavItemCategory)
            locSelectedCatIndex = category.findIndex(elem => elem.ISA_FAVS_CATEGORY === locmenuFavItemCategory)
        }
        if (locSelectedCatIndex == -1 || locSelectedCatIndex == null || locSelectedCatIndex == undefined) {
            locSelectedCatIndex = 0
        }

        console.log("menu- click index", locSelectedCatIndex)
        console.log("menu- click cat", locSelectedCat)
        this.SelectSubCategory("pageLoad", locSelectedCat.ISA_FAVS_CATEGORY, locSelectedCatIndex, locSelectedCat);
        CookieService.updateLocalStorageValues("menuFavItemCategory", "");
    }
    //[2/16/22], WW-330, Dhevanesam R
    warehouseqtyresponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Workorderresponse = JSON.parse(ShoppingCartStore.workorderresponse);
        let local = Workorderresponse.Table
        let st = 0
        let GridArrResponse = this.state.GridArr
        if (local.length > 0) {
           
            local.forEach((x) => {

                if (x.QTY != null) {
                    st = x.QTY.split('^')[0];
                    
                    console.log("hasBenItemVal", x.QTY.slice(-1))
                    GridArrResponse.forEach((value, index) => {
                        if (GridArrResponse[index].ISA_CP_ITEM_ID == x.INV_ITEM_ID) {
                            value.hasBenItemVal = x.QTY.slice(-1);
                            
                            if (st == 0) {
                                
                                value.InvItemQtyCheck = true
                            }
                        }

                    });
                }
            })
        }
        this.setState({
            GridArr: GridArrResponse
        })
        
        console.log("GridArrResponseCribFavItem", GridArrResponse)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    AssignNewFavItem = () => {
        let PageLoadResponse = JSON.parse(FavItemMainStore.PageLoadData);
        let New = [];
        
        New = PageLoadResponse.ResultFavDetail;
        if (PageLoadResponse.errorT) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Invalid item id"
            });
            //  alert("Invalid item id");
            return;
        }
        if (New) {
            this.setState({ NewItem: PageLoadResponse.ResultFavDetail, yourCat: "", yourDes: "", CategoryErr: false, SubCategoryErr: false, FavSubCategory: "", attachmentPathArr: [] });
            console.log("NewItemArr", PageLoadResponse.ResultFavDetail);

        }


    }

    InsertNewFavItem = () => {
        let PageLoadResponse = JSON.parse(FavItemMainStore.PageLoadData);
        let srtxt = ""
        if (searchTxt != "") {
            srtxt = $(`#searchTxt`).val().trim();
        }
        this.favPageLoad("1", this.state.RecCount, srtxt, searchCol, "ISA_FAVS_CATEGORY", this.state.SortingVal)
        // window.location.reload();
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log("PageLoadResponse", PageLoadResponse)
        let Favstatus = PageLoadResponse.ErrorMsg
        if (Favstatus.length > 0) {
            if (Favstatus[0].Error_Msg == "Favorite item inserted sucessfully") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Insertion failed"
                });
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Favorite item inserted sucessfully"
                });
                // alert("Favorite item inserted sucessfully");
                let srtxt = ""
                if (searchTxt != "") {
                    srtxt = $(`#searchTxt`).val().trim();
                }
                $('#add-fav-popup').modal('hide');
                //this.favPageLoad(this.state.PageNo, this.state.RecCount, srtxt, searchCol, "ISA_FAVS_CATEGORY", this.state.SortingVal)
                //window.location.reload();
            }
            //Fav Item - When we fav an item using New in the Fav Item Maintanence panel, it is keep on loading - Deepthi
            else if (Favstatus[0].Validation_Error_Msg == "Item already in favorite list.'") {
                $('#add-fav-popup').modal('hide');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Item Is Already Favorited"
                });
                // alert("Item Is Already Favorited");
            }
            else if (Favstatus[0].Error_Msg == "Invalid or the itemid already exists") {
                $('#add-fav-popup').modal('hide');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Invalid or the itemid already exists"
                });
                // alert("Invalid or the itemid already exists");
            }
            else {
                $('#add-fav-popup').modal('hide');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Technical Issue Try again"
                });
                // alert("Technical Issue Try again")
            }
        }
        isPostBack = false;
        this.setState({ Response: PageLoadResponse.ErrorMsg, CategoryErr: false, SubCategoryErr: false });
        return;
    }

    DelFavItem = () => {
        let PageLoadResponse = JSON.parse(FavItemMainStore.PageLoadData);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: "Deleted successfully"
        });
        // alert("Deleted successfully");
        let srtxt = ""
        if (searchTxt != "") {
            srtxt = $(`#searchTxt`).val().trim();
        }
        this.favPageLoad("1", this.state.RecCount, srtxt, searchCol, "ISA_FAVS_CATEGORY", this.state.SortingVal)
        // window.location.reload();
        this.setState({ Response: PageLoadResponse.ResultFlag });

        this.setState({ RemainItemId: "" });
        MenuAction.refreshMasterData();

        isPostBack = false;
        return
    }

    UpdateFavItembind = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let PageLoadResponse = JSON.parse(FavItemMainStore.PageLoadData);
        // this.setState({ Response: PageLoadResponse.ResultFlag });
        
        console.log("PageLoadResponse", PageLoadResponse[0].updateResult);
        MenuAction.refreshMasterData();
        if (PageLoadResponse) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "updated successfully"
            });
            //  alert("updated successfully");
        }
        this.setState({ RemainItemId: "" });

        this.favPageLoad("1", this.state.RecCount, searchTxt, searchCol, this.state.SortingColumn, this.state.SortingType);

        isPostBack = false;
        return;
    }


    handlePageClick = (data) => {
        let pageNo = data.selected + 1;


        //$('.accordion-arrow').removeClass('accordion-arrow-change');
        //$('.hiddenRow').hide();
        //$('tr').removeClass('tr-border');
        this.setState({ PageNo: pageNo });

        //searchTxt = $(`#searchTxt`).val().trim();


        //WAL-541_PC_17 -Aparna
        //this.favPageLoad(
        //    pageNo, this.state.RecCount,
        //    searchTxt, searchCol,
        //    this.state.SortingColumn, this.state.SortingType);


        
        isPostBack = false;
    };

    AddNewFav = (value) => {
        $('#add-fav-popup').modal('show');
        $('#NewItemId').val('');
        $('#savebuttonid').hide();


        this.setState({ yourCat: "", yourDes: "", NewItem: [], CategoryErr: false, SubCategoryErr: false, FavSubCategory: "", attachmentPathArr: [] });
    }

    NewItemClick = () => {
        let newItemId = $('#NewItemId').val().toUpperCase();
        console.log("newItemId", newItemId);
        if ($('#NewItemId').val() != "") {
            this.setState({ NewItem: [] });
            let newItemIdBO = {
                ItemId: newItemId,
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX")

            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            FavItemMainAction.NewFavItem(newItemIdBO);
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Item Id"
            });
            // alert("Please enter Item Id");
        }

    }

    InsertFavItem = () => {
        

        if ($('#NewItemId').val() != "") {
            let newItemId = $('#NewItemId').val().trim();
            if (this.state.yourCat != undefined && this.state.yourCat != null && this.state.FavSubCategory != undefined && this.state.FavSubCategory != null) {
                if (this.state.yourCat.trim() != "" && this.state.FavSubCategory.trim() != "") {
                    let InsertFavItemBO = {
                        ItemId: newItemId,
                        YourCat: this.state.yourCat.toUpperCase(),
                        YourSubCat: this.state.FavSubCategory.toUpperCase(),
                        YourDesc: this.state.yourDes.toUpperCase(),
                        Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                        Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                        Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                        Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                        Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                        Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                        Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                        Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                        Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                        Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                        Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                        Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                        Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                        Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                        SDI_Catagory: $('#sdiCategory').text(),
                        txtMfgItemidHide: this.state.NewItem[0].manfPartNumber,
                        SAP: this.state.NewItem[0].customer_part_number_woprefix != "\N" && this.state.NewItem[0].customer_part_number_woprefix.trim() != "" && this.state.NewItem[0].customer_part_number_woprefix.trim() != null && this.state.NewItem[0].customer_part_number_woprefix.trim() != undefined ? this.state.NewItem[0].customer_part_number_woprefix : " ",
                        //[12/9/21, PC_FI_01, Bug - 1866, Dhevanesam R]
                        txtMFGHide: this.state.NewItem[0].vendor_id,
                        Manufacturer: this.state.NewItem[0].manufacturer,
                        ImgByteCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null),
                        IsWeb: true,
                        SupplierID: this.state.NewItem[0].vendor_id,
                        FileNameCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null)
                    }
                    console.log("sapitem", this.state.NewItem[0].customer_part_number_woprefix ? " " : this.state.NewItem[0].customer_part_number_woprefix)
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    FavItemMainAction.InsertFav(InsertFavItemBO);
                }
                else {
                    this.setState({ CategoryErr: this.state.yourCat.trim() == "" ? true : false, SubCategoryErr: this.state.FavSubCategory.trim() == "" ? true : false });
                    // this.setState({ CategoryErr: true });
                }
            }
            else {
                this.setState({ CategoryErr: this.state.yourCat == null || this.state.yourCat == undefined ? true : false, SubCategoryErr: this.state.FavSubCategory == null || this.state.FavSubCategory == undefined ? true : false });
                // this.setState({ CategoryErr: true });
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Item Id"
            });
            //  alert("Please enter Item Id");
            this.setState({ CategoryErr: false, SubCategoryErr: false });
        }
    }

    DeleteFav = (e, value) => {
        e.preventDefault();
        $('#Cancel-confirmation').modal('show');
        this.setState({ RemainItemId: value.ISA_CP_ITEM_ID, delMFG: value.MANUFACTURER, delMFGpart: value.CLIENT_MFG_PART, delSupp: value.SUPPLIER_ID, deleteFlag: value.ISA_CATALOG_FLAG, deleteComments: value.ISA_COMMENTS });
        console.log("value.ISA_CP_ITEM_ID ", value.ISA_CP_ITEM_ID);
    }

    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Favorite Item Maintenance",//WW-243 Fav Pages Sync Issue - Deepthi
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            FavItemMainAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            FavItemMainAction.deleteFavPage(deleteFavPageBO)
        }
    };


    ConfirmationNO = () => {
        this.setState({ RemainItemId: "", delMFG: "", delMFGpart: "", delSupp: "", multiDelete: false });
        console.log("RemainItemId", this.state.RemainItemId);

    }

    ConfirmationYES = () => {

        let deleteFavBO = {
            ItemId: this.state.RemainItemId,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"), // WW-368_deletion_PC-06
            MFG: this.state.delMFG,
            MFGpartnum: this.state.delMFGpart,
            SupplierId: this.state.delSupp,
            ISA_CATALOG_FLAG: this.state.deleteFlag,
            ISA_COMMENTS: this.state.deleteComments,
            isFromFav: true,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        FavItemMainAction.DeletFavItem(deleteFavBO);
    }

    EditFav = (value, popupdetail) => {
       
        if (document.getElementById("lblerror") != null) {
            document.getElementById("lblerror").innerText = "";
        }

        // e.preventDefault();
        $('#edit-fav-popup').modal('show');
        /*[03/20/22,PC_09,WW-373], Priyanka D */
        // to get the edited description of the item (9/19/2022)-Aparna
        this.setState({
            EditValue: value, RemainItemId: value.ISA_CP_ITEM_ID, yourCat: popupdetail == "Yes" ? this.state.yourCat : value.ISA_FAVS_CATEGORY, yourDes: popupdetail == "Yes" ? this.state.yourDes : value.ISA_CP_FAV_ALT_DSC,
            attachmentPathArr: [], CategoryErr: false, SubCategoryErr: false, FavSubCategory: popupdetail == "Yes" ? this.state.FavSubCategory : value.ISA_FAVS_SUBCATEGORY
        });
        //console.log("value.ISA_CP_ITEM_ID ", value.ISA_CP_ITEM_ID);

    }

    updatFavItem = (value, ImgNo = false) => {
        //e.preventDefault();
        this.setState({ EditItem: value });
        let cat = " ";
        let Des = " ";
        if (this.state.yourCat != "") {
            cat = this.state.yourCat;

        }
        if (this.state.yourDes != "") {
            Des = this.state.yourDes;
        }
        //BUG-2686 to check the category (9/21/2022)-Aparna
        //if (ImgNo == true && (!(value.IMAGE_NAME.includes(".JPG") || (value.IMAGE_NAME.includes(".jpg")))) && this.state.attachmentPathArr.length == 0) {
        //    $('#add-fav-img').modal('show');
        //    $('#edit-fav-popup').modal('hide'); //BUG-2686 
        //}
        //  else {
        if (this.state.yourCat != null && this.state.yourCat != undefined && this.state.FavSubCategory != null && this.state.FavSubCategory != undefined) {
            if (this.state.yourCat.trim() != "" && this.state.FavSubCategory.trim() != "") {
                //BUG-2686 to check the category (9/21/2022)-Aparna
                if (value.IMAGE_NAME == null || value.IMAGE_NAME == undefined) {
                    value.IMAGE_NAME = ""
                }
                if (ImgNo == true && ((!(value.IMAGE_NAME.includes(".PNG") || (value.IMAGE_NAME.includes(".png"))) && !(value.IMAGE_NAME.includes(".JPEG") || (value.IMAGE_NAME.includes(".jpeg"))) && !(value.IMAGE_NAME.includes(".JPG") || (value.IMAGE_NAME.includes(".jpg"))))) && this.state.attachmentPathArr.length == 0) {
                    //if ((!(value.IMAGE_NAME.includes(".PNG") || (value.IMAGE_NAME.includes(".png"))) && !(value.IMAGE_NAME.includes(".JPEG") || (value.IMAGE_NAME.includes(".jpeg"))) && !(value.IMAGE_NAME.includes(".JPG") || (value.IMAGE_NAME.includes(".jpg"))))) {
                    $('#add-fav-img').modal('show');
                    $('#edit-fav-popup').modal('hide'); //BUG-2686 
                    //}
                }
                else {
                    $('#edit-fav-popup').modal('hide');
                    /*[03/20/22,PC_09,WW-373], Priyanka D */
                    let UpdateFavBO = {
                        ItemId: this.state.RemainItemId,
                        yourCat: cat,
                        yourSubCat: this.state.FavSubCategory,
                        yourDec: Des,
                        Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                        Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                        MFG: value.MANUFACTURER,
                        MFGpartnum: value.CLIENT_MFG_PART,
                        SupplierId: value.SUPPLIER_ID,
                        ISA_CATALOG_FLAG: value.ISA_CATALOG_FLAG,
                        ISA_COMMENTS: value.ISA_COMMENTS,
                        ImgByteCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null),
                        IsWeb: true,
                        FileNameCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null)
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    FavItemMainAction.UpdateFavItem(UpdateFavBO);
                }
            }
            else {
                this.setState({ CategoryErr: this.state.yourCat.trim() == "" ? true : false, SubCategoryErr: this.state.FavSubCategory.trim() == "" ? true : false });
                // this.setState({ CategoryErr: true });
            }
        }
        else {
            this.setState({ CategoryErr: this.state.yourCat == null || this.state.yourCat == undefined ? true : false, SubCategoryErr: this.state.FavSubCategory == null || this.state.FavSubCategory == undefined ? true : false });
            //this.setState({ CategoryErr: true });
        }
        // }
    }

    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    handleEquipmentYes = () => {
        $('#FavItemMixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        this.Addtocart("", this.state.AddValue, this.state.rowindex, this.state.equipmentCore);
    };

    handleEquipmentNo = () => {
        $('#FavItemMixedOrderConfirmPopup').modal('hide');
        cartDelete = false;
    };

    Addtocart = (e, value, index, IsCoreCheck) => {
        if (e) {
            e.preventDefault();
        }
        debugger
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            let hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            let hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
            if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
                $('#FavItemMixedOrderConfirmPopup').modal('show');
                this.setState({ AddValue: value, rowindex: index, equipmentCore: IsCoreCheck, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
            else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
                $('#FavItemMixedOrderConfirmPopup').modal('show');
                this.setState({ AddValue: value, rowindex: index, equipmentCore: IsCoreCheck, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
        }
        let isItemInCart = cartItems.some(item => item.Itemid === value.ISA_CP_ITEM_ID);
        if (value.ISA_CATALOG_FLAG != "NA") {
            let itemid = value.ISA_CP_ITEM_ID;
            let ItemCat = value.ITEM_CATEGORY;
            let SupplierName = value.SUPPLIER_NAME;
            //let qty = this.state.qty;
            //let itemsSelected = this.state.GridArr.filter((item) => item.ISA_CP_ITEM_ID == value.ISA_CP_ITEM_ID);
            //console.log("itemsee", itemsSelected);
            //let itemsToAdd = [];
            //let quty = "";
            //if (this.state.id == value.ISA_CP_ITEM_ID) {
            //    quty = this.state.itemQuantity;
            //};
            //if (!quty) {
            //    alert("Please enter quanity for the selected line items");
            //    return false;
            //};

            //itemsSelected.forEach((value) => {
            //    itemsToAdd.push({
            //        ISA_CP_ITEM_ID: value.ISA_CP_ITEM_ID,
            //        Quantity: quty,

            //    });

            //});
            // WW-295 removeing quantity field (12/15/2021)-Aparna 
            //let filteredArray = this.state.GridArr.filter((f) => f.QTY_REQUESTED != "");
            //if (filteredArray.length == 0) {

            //    alert("Please enter quantity");
            //    return;
            //}
            let cartstorage = []
            if (localStorage.getItem("CartStorage") != null) {
                cartstorage = JSON.parse(localStorage.getItem("CartStorage"));

            }

            if (value.CORECHARGES == "CORE" && IsCoreCheck == false) {
                this.setState({ IskitCoreDisplay: false });
                $('#CoreChargePopUpFav').modal('show');
                return
            }
            let lineItemsID = [];
            let locarr = this.state.GridArr[index];
            if (value.KIT_ITEMS != " " && value.KIT_ITEMS != null && value.KIT_ITEMS != undefined) {
                let Kit_Components = [];
                Kit_Components = JSON.parse(locarr.KIT_ITEMS)
                let CoreKIT = Kit_Components.filter((item, index) => item.IsCore == true);
                if (CoreKIT.length > 0) {
                    this.setState({ IskitCoreDisplay: true });
                    // IskitCoreDisplay = true
                    $('#CoreChargePopUpFav').modal('show');

                    return
                }
            }

            this.setState({
                addItemMessage: isItemInCart ? "The item quantity has been updated in the cart" : "Item added successfully",
                itemsAddedToCart: !isItemInCart ? { ...this.state.itemsAddedToCart, [value.ISA_CP_ITEM_ID]: true } : this.state.itemsAddedToCart,
            });





            if (value.KIT_ITEMS != " " && value.KIT_ITEMS != null && value.KIT_ITEMS != undefined) {
                let Kit_Components = JSON.parse(locarr.KIT_ITEMS)

                Kit_Components.forEach((value) => {
                    lineItemsID.push({
                        ItemID: value.SupplierPartNumber,
                        MFGPartNum: "",
                        SupplierID: value.SupplierID,
                        Manufacturer: "",
                        SupplierPartNo: value.SupplierPartNumber,
                        Quantity: value.MiniumOrderQty,
                        IsKit: true

                    });
                });
            }
            else {
                lineItemsID.push({
                    ItemID: locarr.ISA_CP_ITEM_ID,
                    //MFG: locarr.MANUFACTURER.replaceAll('&', '&amp;'),// BUG 2242 replaced '&, &amp' (06/16/2022)-Pavithra R
                    MFGPartNum: locarr.CLIENT_MFG_PART,
                    SupplierID: locarr.SUPPLIER_ID,
                    Manufacturer: locarr.MANUFACTURER,
                    SupplierPartNo: locarr.ISA_CP_ITEM_ID,
                    Quantity: 1,//eachfilter.QTY_REQUESTED,// WW-295 removeing quantity field (12/15/2021)-Aparna
                    IsKit: false,



                });
            }

            //    let cartcontain = false
            //    if (cartstorage.length > 0) {


            //        cartstorage.map((x) => {
            //            let mfgname = lineItemsID[0].Manufacturer
            //           // mfgname = mfgname.replaceAll('&amp;', '&');// BUG 2270 replaced '&amp;, &' (06/16/2022)-Pavithra R
            //            // mfgname = mfgname.replaceAll("'", " ");// replaced '', ' (06/16/2022)-Pavithra R
            //            //mfgname = mfgname.replaceAll("&apos;", "'");// BUG 2270 replaced '&amp;, &' (06/16/2022)-Pavithra R
            //            
            //            if (x.Itemid.toLowerCase() == lineItemsID[0].ItemID && x.Manufacturer.includes("&apos;") ? x.Manufacturer.replace("&apos;", "'") : x.Manufacturer == mfgname && x.Manufacturerpartnumber == lineItemsID[0].MFGPartNum) {

            //                cartcontain = true
            //            }

            //        })
            //    }


            //if (cartcontain == true) {
            //    swal({
            //        allowOutsideClick: false,
            //        closeOnClickOutside: false,
            //        text: "Item " + value.ISA_CP_ITEM_ID.toUpperCase() + " Is Already In Cart"
            //    });


            //    }

            console.log("id", lineItemsID);
            //f (cartcontain == false) {
            let AddtoCartBO = {
                //ItemId: itemid,
                LineItems: lineItemsID,
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ZEUS_SITE: CookieService.getLocalStorageValues("Session_ZEUS_SITE"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                Session_ZEUSNOCATALOGSITE: CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE"),
                ITEM_CAT: ItemCat,
                /*[12/24/21, PC_SC_14], Priyanka D//Passing the Location value */
                Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
                Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
                //[1/20/23, WW-542_PC_20, Dhevanesam R]
                ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
                EquipmentDelete: cartDelete,
                Interactive: false,
                SOURCE: "WEB"
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            FavItemMainAction.AddToCartFavItem(AddtoCartBO);
        }
    }
    CoreChargePopUpclose = (e) => {

        $('#CoreChargePopUpFav').modal('hide');
        this.setState({ IskitCoreDisplay: false });

    }
    CoreChargeProceedClick = (e) => {
        $('#CoreChargePopUpFav').modal('hide');
        this.setState({ IskitCoreDisplay: false });
        let IsCoreCheck = true;
        this.Addtocart(e, this.state.AddValue, this.state.rowindex, IsCoreCheck)

    }

    handleChange = (event) => {
       
        this.setState({ [event.target.name]: event.target.value });
        console.log("name", event.target.value);
    };


    filterClick = (event, displayName, columnName) => {
        event.preventDefault();
        this.setState({ filterDisplayName: displayName, searchCol: columnName });
        console.log("searchColumn", columnName);
        searchCol = columnName;
    }

    handleSearch = () => {
        let pageNo = 1;

        let sortColumn = "ISA_CP_ITEM_ID";
        let sortType = "ASC";
        //searchTxt = $(`#searchTxt`).val().trim();
        searchTxt = $(`#searchTxt`).val().toLowerCase();
        console.log("SEARCHTXT", searchTxt);
        isPostBack = false;
        this.favPageLoad(pageNo,
            this.state.RecCount,

            searchTxt, searchCol,
            sortColumn,
            sortType
        );
       
        console.log("search", this.state.searchCol);
        this.setState({ PageNo: pageNo });

    }

    RedirectTo = (event, pageName) => {
        let queryParamindex = pageName.indexOf("?");
        let pagePath = pageName;
        let queryParams = "";
        if (queryParamindex > 0) {
            pagePath = pageName.substring(0, queryParamindex);
            queryParams = pageName.substring(queryParamindex, pageName.length);
        };

        event.preventDefault();
        this.props.history.push({
            pathname: pagePath,
            search: queryParams
        });
    };


    Sorting = (sortType, sortColumn) => {
        let sc
        //if (this.state.isSearch) {

        //    sc = $(`#searchTxt`).val().trim()

        //}
        //if (this.state.searchTrTxt !== "") {

        //}
        //let isArchi = "N";
        //if (isArchieved == true) {
        //    isArchi = "Y"
        //}
        //this.setState({ sSearchCriteria: sc });
        let pageNo = 1;
        let searchcol = "";
        isPostBack = false;
        let searchtxt = $(`#searchTxt`).val().trim();
        if (searchtxt != "") {
            searchcol = searchCol;
        }

        this.favPageLoad(
            pageNo, this.state.RecCount,
            searchtxt, searchcol,
            sortColumn, sortType);

        this.setState({ pageNo: pageNo, SortingColumn: sortColumn, SortingType: sortType });
    }
    onquantityChange = (e, val, index) => {
        e.preventDefault();
        let value = val.ISA_CP_ITEM_ID;
        let itemsToAdd = [];
        let i = $(`#itemQuantity${index + 1}`).val().trim();
        const re = SDIConstants.quantityRegEX;
        let { itemQuantity } = this.state;
        
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value != "0") {
                let { GridArr } = this.state;
                GridArr[index].QTY_REQUESTED = e.target.value;

                let { id } = this.state;
                id.push({
                    ISA_CP_ITEM_ID: value,
                    Quantity: i,

                });
                // this.setState({ id: id });
                //this.setState({ itemQuantity: i, id: value });
                //this.state.id.push({
                //    ISA_CP_ITEM_ID: value,
                //    Quantity: i,

                //});
                this.setState({ itemQuantity: i, id: id, GridArr: GridArr });
                console.log("itemsToAdd", itemsToAdd);
                console.log("itemQuantity", (e.target.value));
                console.log("id", this.state.id);
            }
            //this.setState({ itemQuantity});
        }
        //else {
        //    //alert("not valid quantity");
        //    //document.getElementById(`#itemQuantity${index + 1}`).innerText = "2";
        //    //$(`#itemQuantity${index + 1}`).val('');
        //    //this.setState({ itemQuantity: 2 });
        //}
    }
    keyPress(e) {
        if (e.keyCode == 13) {
            ////;
            if ($("#NewItemId").val() != "") {
                this.NewItemClick();
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter Item Id"
                });
                // alert("Please enter Item Id");
            }

        }
    }

    /*[07/18/22, 2382-Item cannot be added to cart, Priyanka D */
    //[1/25/23, WW-542_PC_22, Dhevanesam R]
    showitemdetails = (index, ItemId, manufactpartnum, mfg_std, vendor_id, event, childItem) => {
        
        $('#cheaperitem-popup').modal('hide');
        if (event) {
            event.preventDefault();
        }


        let Itemtypevalue = ItemId.indexOf("NONCAT") > -1 ? "NONCAT" : "CAT";

        CookieService.updateLocalStorageValues("Session_Noncat", Itemtypevalue);
        CookieService.updateLocalStorageValues("ItemDetail_ItemId", ItemId);
        CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", mfg_std);
        CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", manufactpartnum);
        CookieService.updateLocalStorageValues("ItemDetail_SupplierID", vendor_id);
        // CookieService.updateLocalStorageValues("ItemDetail_QTY", qtt);
        /*[07/18/22, 2382-Item cannot be added to cart, Priyanka D */
        let ItemData = {
            vendor_id: vendor_id,
            ItemPrice: childItem.PRICE,
            txtDesc: childItem.ITEM_DESC

        }
        if (Itemtypevalue != "NONCAT") {
            //[2/28/22], PC_IC_08, WW-316, Dhevanesam R
            if (window.location.pathname.toLowerCase() == "/itemdetailnew") {
                this.props.history.push({
                    pathname: `\itemdetailnew`,
                    search: `?ItemId=${ItemId}&ManufacturePartNumber=${mfg_std}&ManufactureName=${manufactpartnum}&SupplierID=${vendor_id}`,
                    state: { ItemData: ItemData, origin: 'favitem', Suggesstions: true, ItemId: ItemId, ManufacturePartNumber: mfg_std, ManufactureName: manufactpartnum, SupplierID: vendor_id }
                });
                window.location.reload()
            }
            else {
                
                this.props.history.push({
                    pathname: `\itemdetailnew`,
                    search: `?ItemId=${ItemId}&ManufacturePartNumber=${mfg_std}&ManufactureName=${manufactpartnum}&SupplierID=${vendor_id}`,
                    state: { ItemData: ItemData, origin: 'favitem', Suggesstions: true, ItemId: ItemId, ManufacturePartNumber: mfg_std, ManufactureName: manufactpartnum, SupplierID: vendor_id }
                });
            }
            CookieService.updateLocalStorageValues("SelectedCatIndexFavItem", this.state.SelectedCatIndex);
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Details are not available for Non-Catalog items"
            });
        }

    }



    AnykeyPress(e) {
        if (e.keyCode == 13) {
          

            if ($("#searchTxt").val() != "") {
                this.handleSearch();
            }
            else {
                this.handleSearch();
            }

        }
    }
    //handleSTrTxt = (event) => {
    //    //this.setState({ searchC: [event.traget.value] });
    //    let item = $('#NewItemID').val();
    //    searchTrCriteria = $('#SearchTrTxt').val();
    //    //////;
    //}
    //WW-368_SuggestionCat_for_favItem_PC_03
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }
    //WW-368_SuggestionCat_for_favItem_PC_03
    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }
    //WW-368_SuggestionCat_for_favItem_PC_03
    onSelect = (val, name) => {
        let result = [];
        //WW-516_PC_09
        if (name == "Cat") {
            if (val != "") {
                this.state.subCategory.forEach((x, i) => {
                    if (val.toUpperCase() == x.category) {
                        result.push({ label: x.value, value: x.value })
                    }
                }
                )
            }
            this.setState({
                yourCat: val, subCategoryResults: result
            });
        }
        else {
            this.setState({
                FavSubCategory: val
            });
        }

    }
    //WW-368_SuggestionCat_for_favItem_PC_03
    onChange = (e, name) => {
        let val = e.target.value.toUpperCase()
        let len = e.target.value
        let result = [];
        let subcatresult = [];
        //[1/25/23, WW-542_PC_26, Dhevanesam R]
        let re = /^[a-zA-Z0-9_-\s\x20 &, :;=?@#|'<>.{}"*()%!`%^$+~[/\]\\]+$/;
        //WW-516_PC_08
        if (val === '' || re.test(val)) {
            if (name == "Cat") {
                if (e.target.value == "") {
                    let result = this.state.autocompleteData
                    this.setState({
                        yourCat: e.target.value, autocompleteDataRstl: this.state.autocompleteData
                    });
                }
                else if (len.length <= 40) {
                    console.log("yourcat autocomplete", this.state.autocompleteData)
                    if (this.state.autocompleteData != undefined && this.state.autocompleteData != null) {
                        if (this.state.autocompleteData.length != 0) {
                            result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))
                            console.log("yourcat autocomplete", result)
                        }
                    }
                    if (e.target.value != "") {
                        this.state.subCategory.forEach((x, i) => {
                            if (e.target.value.toUpperCase() == x.category) {
                                subcatresult.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                    }
                    this.setState({
                        yourCat: e.target.value, autocompleteDataRstl: result, subCategoryResults: subcatresult
                    });
                }
            }
            else {
                if (e.target.value == "") {
                    //let result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))
                    if (this.state.yourCat != "") {
                        this.state.subCategory.forEach((x, i) => {
                            if (this.state.yourCat.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                        result = result.filter(name => name.label.toUpperCase().includes(val))
                    }

                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: result
                    });
                }
                else if (len.length <= 40) {
                    //let subcat = this.state.subCategory;
                    //if (this.state.yourCat != "" && this.state.yourCat != null && this.state.yourCat != undefined) {
                    //    subcat = this.state.subCategory.filter(name => name.label.toUpperCase().includes(val) && name.)
                    //}
                    if (this.state.yourCat != "") {
                        this.state.subCategory.forEach((x, i) => {
                            if (this.state.yourCat.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                        result = result.filter(name => name.label.toUpperCase().includes(val))
                    }

                    console.log("sugg result", result)
                    console.log("sugg this.state.subCategory", this.state.subCategory)
                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: result
                    });
                }
                else if (this.state.FavSubCategory == "" && e.target.value == "") {
                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: this.state.subCategory
                    });
                }
            }

        }


        /**
         * Handle the remote request with the current text !
         */

    }

    bindNewFavItemDetail = () => {
       
        //{ value.CategoyID }
        console.log("newitem", this.state.NewItem[0]);
        console.log("math", Math.floor(Math.random() * 10000000000))
        console.log("math", Math.floor(Math.random()))
        if (this.state.NewItem.length > 0) {
            $('#savebuttonid').show();
            //return this.state.NewItem.map((value, index) => {
            //console.log("newitem", value.customerPartnumber_CatalogZero);
            console.log("newitem", $('#NewItemId').val());
            //if (this.state.NewItem[0].customerPartnumber_CatalogZero == $('#NewItemId').val()) {

            return (
                <>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label"><span>SDI </span><Trans>Category</Trans></label>
                        <label className="col-md-7 quick-value" id="sdiCategory">{!this.state.NewItem[0].UNSPSCCategory.trim() ? "Unclassified" : this.state.NewItem[0].UNSPSCCategory}</label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label indicate-alert" ><Trans>Category</Trans></label>
                        {/*<div className="col-md-7">
 
                            <textarea className="form-control custom-textarea" rows={3} name="yourCat" maxLength="40" value={this.state.yourCat} onChange={this.handleChange} />

                        </div>*/}
                        {/** //WW-368_SuggestionCat_for_favItem_PC_02*/}
                        <div className="float-left search-autocomplete col-md-7 home-search " style={{ zIndex: "9999" }}>
                            {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                            <Autocomplete
                                getItemValue={this.getItemValue}
                                items={this.state.autocompleteDataRstl}
                                renderItem={this.renderItem}
                                value={this.state.yourCat}
                                onChange={e => this.onChange(e, "Cat")}
                                onSelect={e => this.onSelect(e, "Cat")}
                                inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                maxLength="40"
                                id="yourcat"
                            />
                            <span className="errorspan1" style={{ fontSize: '10px' }} id="favordcatid" />
                            {this.state.CategoryErr ? <span className=" W-100 errorspan1 text-left " style={{ fontSize: '15px' }}>Enter Category </span> : null}
                        </div>

                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label indicate-alert" ><Trans>Sub Category</Trans></label>
                        {/*<div className="col-md-7">
 
                            <textarea className="form-control custom-textarea" rows={3} name="yourCat" maxLength="40" value={this.state.yourCat} onChange={this.handleChange} />

                        </div>*/}
                        {/** //WW-368_SuggestionCat_for_favItem_PC_02*/}
                        <div className="float-left search-autocomplete col-md-7 home-search " >
                            {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                            <Autocomplete
                                getItemValue={this.getItemValue}
                                items={this.state.subCategoryResults}
                                renderItem={this.renderItem}
                                value={this.state.FavSubCategory}
                                onChange={e => this.onChange(e, "Subcat")}
                                onSelect={e => this.onSelect(e, "Subcat")}
                                inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                maxLength="40"
                                id="yoursubcat"
                            />
                            <span className="errorspan1" style={{ fontSize: '10px' }} id="favordcatid" />
                            {this.state.SubCategoryErr ? <span className=" W-100 errorspan1 text-left " style={{ fontSize: '15px' }}>Enter Sub Category </span> : null}
                        </div>

                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label"><Trans>Description</Trans></label>
                        <label className="col-md-7 quick-value ">{this.state.NewItem[0].Description == "" ? "-" : this.state.NewItem[0].Description}</label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label"><Trans>Notes</Trans></label>
                        <div className="col-md-7">
                            {/* <input type className="form-control custom-textarea " rows={3} value={this.state.yourDes} />*/}
                            <textarea className="form-control custom-textarea" rows={3} name="yourDes" maxLength="100" value={this.state.yourDes} onChange={this.handleChange}></textarea>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label">Manufacturer</label>
                        <label className="col-md-7 quick-value">{this.state.NewItem[0].manufacturer}</label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label"><span>MFG </span><Trans>part number</Trans></label>
                        <label className="col-md-7 quick-value">{this.state.NewItem[0].manfPartNumber}</label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label">Supplier</label>
                        <label className="col-md-7 quick-value">{this.state.NewItem[0].supplierName}</label>
                    </div>
                    {/*[03/20/22,PC_02,WW-373], Priyanka D */}
                    <div className="row mb-3">
                        <label className="col-md-5 quick-label"><span>Your </span><Trans>Image</Trans></label>
                        <div className="col-md-7 mb-0">
                            <div className="text-left">
                                <input type="file" title=" " accept="image/jpeg, image/png" id="customFile" name="filename" style={{ "font-size": "10px" }} onChange={this.handleAttachmentImg} onClick={this.onInputClick} />
                                <label className="custom-file-label ml-3 sdi-font-12" htmlFor="customFile"><Trans>Choose Your Own image</Trans></label>
                                {this.bindAttachments()}
                                <label className="priority-alert" id="lblerror">{this.state.lblerror}</label>
                            </div>
                        </div>
                    </div>
                </>);
            //}
            //})
        }
    }
    /*[03/20/22,PC_03,WW-373], Priyanka D */
    handleAttachmentImg = (event) => {
      
        let files = event.target.files;
        console.log("event", files);
        if (this.state.attachmentPathArr != undefined) {

            if (this.state.attachmentPathArr.length == 0) {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                NonCatalogAction.addAttachment(files);
            } else {

                let lblerror = "You can choose only one Image"
                document.getElementById("lblerror").innerText = lblerror;
            }

        } else {
            document.getElementById("lblerror").innerText = "";
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            NonCatalogAction.addAttachment(files);
        }
    };
    EditFavItemBind = () => {
       
        //BUG-2689 (9/21/2022) -Aparna
        if (this.state.EditValue != null && this.state.EditValue != undefined) {
            let ShiptoValue = this.state.GridArr.filter((item, index) => item.ISA_CP_ITEM_ID == this.state.RemainItemId && this.state.EditValue.CLIENT_MFG_PART == item.CLIENT_MFG_PART && this.state.EditValue.MANUFACTURER == item.MANUFACTURER
                && this.state.EditValue.SUPPLIER_ID == item.SUPPLIER_ID);
            //defaultValue={Item.ISA_FAVS_CATEGORY} 
            //defaultValue={Item.ISA_CP_FAV_ALT_DSC}
            console.log("edit image popup", ShiptoValue);
            console.log("edit image ", this.state.EditValue.CLIENT_MFG_PART);
            if (ShiptoValue)
                return ShiptoValue.map((Item, index) => {
                    console.log("desc", Item.ISA_CP_FAV_ALT_DSC);
                    return (
                        <div className="modal-body" key={Item.ISA_CP_ITEM_ID}>
                            <div className="row mt-3">
                                <div className="col-12 edit-desc-field mb-4">
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label mt-2"><Trans>Item</Trans><span> </span><Trans>ID</Trans></label>
                                        <div className="col-md-7 quick-value">
                                            {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                                            {Item.CLIENT_MFG_PART}
                                        </div>
                                    </div>
                                    {/*//[6/7/2023], WW-722, LABEL CHANGE PAVITHRA R*/}
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label">Manufacturer</label>
                                        <label className="col-md-7 quick-value">{Item.MANUFACTURER}</label>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label indicate-alert"><Trans>Category</Trans></label>
                                        {/* <div className="col-md-7">
                                        <textarea className="form-control custom-textarea" rows={3} name="yourCat" maxLength="40" value={this.state.yourCat} onChange={this.handleChange}></textarea>
                                    </div>*/}
                                        {/** //WW-368_SuggestionCat_for_favItem_PC_02*/}
                                        <div className="float-left search-autocomplete col-md-7  home-search " style={{ zIndex: "9999" }}>
                                            {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                            <Autocomplete
                                                getItemValue={this.getItemValue}
                                                items={this.state.autocompleteDataRstl}
                                                renderItem={this.renderItem}
                                                value={this.state.yourCat}
                                                onChange={e => this.onChange(e, "Cat")}
                                                onSelect={e => this.onSelect(e, "Cat")}
                                                inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                            />
                                            {this.state.CategoryErr ? <span className=" W-100 errorspan1  text-left " style={{ fontSize: '15px' }}>Enter Category </span> : null}

                                            <span className="errorspan1" style={{ fontSize: '10px' }} id="favordcatid" />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label indicate-alert"><Trans>Sub Category</Trans></label>
                                        {/* <div className="col-md-7">
                                        <textarea className="form-control custom-textarea" rows={3} name="yourCat" maxLength="40" value={this.state.yourCat} onChange={this.handleChange}></textarea>
                                    </div>*/}
                                        {/** //WW-368_SuggestionCat_for_favItem_PC_02*/}
                                        <div className="float-left search-autocomplete col-md-7  home-search " >
                                            {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                            <Autocomplete
                                                getItemValue={this.getItemValue}
                                                items={this.state.subCategoryResults}
                                                renderItem={this.renderItem}
                                                value={this.state.FavSubCategory}
                                                onChange={e => this.onChange(e, "Subcat")}
                                                onSelect={e => this.onSelect(e, "Subcat")}
                                                inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                            />
                                            {this.state.SubCategoryErr ? <span className=" W-100 errorspan1  text-left " style={{ fontSize: '15px' }}>Enter Sub Category </span> : null}

                                            <span className="errorspan1" style={{ fontSize: '10px' }} id="favordcatid" />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><Trans>Description</Trans></label>
                                        <label className="col-md-7 quick-value ">{Item.ITEM_DESC}</label>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><Trans>Notes</Trans></label>
                                        <div className="col-md-7 quick-value">
                                            <textarea className="form-control custom-textarea" rows={3} name="yourDes" maxLength="100" value={this.state.yourDes} onChange={this.handleChange}></textarea>
                                        </div>
                                    </div>
                                    {/*//[6/7/2023], WW-722, LABEL CHANGE PAVITHRA R*/}
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><Trans> Supplier </Trans></label>
                                        <label className="col-md-7 quick-value">{Item.SUPPLIER_NAME}</label>
                                    </div>
                                    {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><Trans> Supplier Part# </Trans></label>
                                        <label className="col-md-7 quick-value">{Item.ISA_CP_ITEM_ID}</label>
                                    </div>
                                    {/*[03/20/22,PC_02,WW-373], Priyanka D*/}
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><span>Your </span><Trans>Image</Trans></label>
                                        <div className="col-md-7 mb-0">
                                            <div className="text-left">
                                                <input type="file" title=" " style={{ "font-size": "10px" }} accept="image/jpeg, image/png" id="customFile" name="filename" onChange={this.handleAttachmentImg} onClick={this.onInputClick} />
                                                <label className="custom-file-label ml-3 sdi-font-12" htmlFor="customFile"><Trans>Choose Your Own image</Trans></label>
                                                {this.bindAttachments()}</div>
                                            <label className="priority-alert" id="lblerror">{this.state.lblerror}</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12 text-center">
                                        <button className="btn btn-primary custom-btn-primary primary-btn" onClick={(e) => this.updatFavItem(Item, true)}>Save</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })
        }
    }
    //when we tried to add the same file for the second time its not inserting
    onInputClick = (event) => {
        event.target.value = ''
    }
    //WAL_541_PC_20
    onAccordianClick = (event, index) => {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        //$(`#contentrow-${index}`).toggleClass('d-none');
        //$('tr').removeClass('tr-border');
        //$(event.currentTarget).parent('tr').addClass('tr-border');

    };
    //WAL-541_PC_21 -Aparna
    SortingCat = (sort, name) => {
        let data = []
        if (sort == "D") {

            data = this.state.CategoryArr.sort((a, b) => (a.ISA_FAVS_CATEGORY > b.ISA_FAVS_CATEGORY) ? 1 : -1);

        }
        else {

            data = this.state.CategoryArr.sort((a, b) => (b.ISA_FAVS_CATEGORY > a.ISA_FAVS_CATEGORY) ? 1 : -1);


        }
        this.setState({ CategoryArr: data })
        let sorttrype = sort == "D" ? "ASC" : "DESC"
        console.log("sorttrype", sorttrype);
        this.setState({ SortingVal: sorttrype });
    }
    //WAL-714 update
    CategoryOnCheck = (type, item, catind) => {
        let { CategoryArr } = this.state;
        let { SubCategoryArr } = this.state;
        let { GridArr } = this.state;
        

        if (type == "cat") {

            //$(`#Category-${catind}`).removeClass('sdi-category-header-active')
            //if (this.state.SelectedCatIndex != catind) {
            //    console.log("catind", catind)
            //    $(`#Category-${this.state.SelectedCatIndex}`).addClass('sdi-category-header-active')
            //    $(`#Category-${catind}`).removeClass('sdi-category-header-active')
            //}
            //if (this.state.SelectedCatIndex == catind) {
            //    $(`#Category-${this.state.SelectedCatIndex}`).addClass('sdi-category-header-active')
            //}
            let I = CategoryArr.findIndex(t => (t.ISA_FAVS_CATEGORY === item.ISA_FAVS_CATEGORY))
            CategoryArr[I].check = CategoryArr[I].check == true ? false : CategoryArr[I].check == false ? true : true;
            this.state.GridArr.forEach((x, index) => {
                if (x.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY) {
                    this.state.GridArr[index].checked = CategoryArr[I].check
                }
            })
            let locsubcat = this.state.GridArr.filter((val, ind) => val.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY)
            SubCategoryArr = locsubcat.filter((v, i, a) => a.findIndex(t => (t.ISA_FAVS_SUBCATEGORY === v.ISA_FAVS_SUBCATEGORY)) === i)
            //if (filteredSubCat.length > 0) {
            //    count = filteredSubCat.length;
            //}
            //WW-514_FI_PC_04 (10/14/2022)-Aparna K
            if (SubCategoryArr != [] && SubCategoryArr != undefined && SubCategoryArr != null) {
                SubCategoryArr.forEach((x, index) => {
                    if (x.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY) {
                        SubCategoryArr[index].SubCatcheck = CategoryArr[I].check
                    }
                })
                this.setState(SubCategoryArr);
            }
            //pc-3820-01 s.sanjay
            let checkedCategories = CategoryArr.filter(category => category.check);
            if (checkedCategories.length == CategoryArr.length) {
                this.setState({ SelectAll: false });
            }
            else {
                this.setState({ SelectAll: true });
            } 
            this.setState(CategoryArr);
        }//WW-514_FI_PC_04 (10/14/2022)-Aparna K
        else if (type == "SubCat") {
            let I = SubCategoryArr.findIndex(t => (t.ISA_FAVS_CATEGORY === item.ISA_FAVS_CATEGORY && t.ISA_FAVS_SUBCATEGORY === item.ISA_FAVS_SUBCATEGORY))
            SubCategoryArr[I].SubCatcheck = SubCategoryArr[I].SubCatcheck == true ? false : SubCategoryArr[I].SubCatcheck == false ? true : true;
            this.state.GridArr.forEach((x, index) => {
                if (x.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY && x.ISA_FAVS_SUBCATEGORY === item.ISA_FAVS_SUBCATEGORY) {
                    this.state.GridArr[index].checked = SubCategoryArr[I].SubCatcheck
                }
            });
            let checkedsubcat = SubCategoryArr.filter((t) => (t.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY && t.SubCatcheck == true))
            let In = CategoryArr.findIndex(t => (t.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY))
            if (SubCategoryArr.length == checkedsubcat.length) {
                CategoryArr[In].check = true;
            }
            else {
                CategoryArr[In].check = false;
            }
            this.setState(CategoryArr);
            //pc-3820-06 s.sanjay
            let allSubCategoryChecked = SubCategoryArr.filter(categor => categor.checked);
            if (allSubCategoryChecked.length == SubCategoryArr.length) {
                this.setState({ SelectAll: false });
            }
            else {
                this.setState({ SelectAll: true });
            }
            this.setState(SubCategoryArr);
        }
        else {
            console.log("catcat", CategoryArr)
            let I = GridArr.findIndex(t => (t.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY && t.ISA_CP_ITEM_ID == item.ISA_CP_ITEM_ID && t.MANUFACTURER == item.MANUFACTURER && t.CLIENT_MFG_PART == item.CLIENT_MFG_PART))
            GridArr[I].checked = GridArr[I].checked == true ? false : GridArr[I].checked == false ? true : true;
            let grid = GridArr.filter((x) => (x.ISA_FAVS_CATEGORY === item.ISA_FAVS_CATEGORY))
            let checkedgrid = GridArr.filter((t) => (t.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY && t.checked == true))
            let In = CategoryArr.findIndex(t => (t.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY))
            if (grid.length == checkedgrid.length) {
                CategoryArr[In].check = true;
            }
            else {
                CategoryArr[In].check = false;
            }

            let itemcheckedlen = GridArr.filter((t) => (t.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY && t.ISA_FAVS_SUBCATEGORY == item.ISA_FAVS_SUBCATEGORY && t.checked == true))
            let itemlen = GridArr.filter((t) => (t.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY && t.ISA_FAVS_SUBCATEGORY == item.ISA_FAVS_SUBCATEGORY))
            let SubIn = SubCategoryArr.findIndex(t => (t.ISA_FAVS_CATEGORY == item.ISA_FAVS_CATEGORY && t.ISA_FAVS_SUBCATEGORY == item.ISA_FAVS_SUBCATEGORY))
            if (itemcheckedlen.length == itemlen.length) {
                SubCategoryArr[SubIn].SubCatcheck = true;
            }
            else {
                SubCategoryArr[SubIn].SubCatcheck = false;
            }
            //pc-3820-10 s.sanjay
            let allGridChecked = GridArr.filter(category => category.checked);
            if (allGridChecked.length == GridArr.length) {
                this.setState({ SelectAll: false });
            }
            else {
                this.setState({ SelectAll: true });
            }
            this.setState(GridArr);
            this.setState(SubCategoryArr);
            //this.setState(CategoryArr);
        }

    }

    //WAL-541_PC_18 -Aparna
    //bindDataGrid = () => {
    //    ////;
    //    if (this.state.GridArr) {
    //        //let category = this.state.GridArr.filter((v, i, a) => a.findIndex(t => (t.ISA_FAVS_CATEGORY === v.ISA_FAVS_CATEGORY)) === i)

    //        return this.state.CategoryArr.map((order, index) => {
    //            console.log("catchecked", order.check)
    //            let orderLineItemCount = this.state.GridArr.filter((i, indexVal) => i.ISA_FAVS_CATEGORY == order.ISA_FAVS_CATEGORY).length;
    //            if (index < parseInt(this.state.PageNo) * 10 && index >= parseInt(this.state.PageNo - 1) * 10) {
    //                return (
    //                    <React.Fragment key={order.ISA_CP_ITEM_ID}>
    //                        <tr>
    //                            <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
    //                                <span className="accordion-arrow" id={`arrow-${index}`} />
    //                            </td>
    //                            <td className="d-sm-none d-md-table-cell" colSpan="11" >{order.ISA_FAVS_CATEGORY == "" || order.ISA_FAVS_CATEGORY == " " ? "Unclassified" : order.ISA_FAVS_CATEGORY}</td>
    //                            <td className="d-sm-none d-md-table-cell">
    //                                <div className="col-3 p-0 float-left ml-5">
    //                                    <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
    //                                        <input type="checkbox" className="custom-control-input" id={`Category-${index}`} name="" checked={order.check} onChange={(e) => this.CategoryOnCheck("cat", order)} />
    //                                        <label className="custom-control-label" htmlFor={`Category-${index}`} />
    //                                    </div>
    //                                    {/* <label className="catalog-label float-left mt-1 space-check " htmlFor="FirstPOOnly"></label>*/}
    //                                </div>
    //                            </td>
    //                            {/* <td colspan="12" style={{ textAlign: "center" }}  title={order.ISA_CP_FAV_ALT_DSC ? order.ISA_CP_FAV_ALT_DSC : ""}>{order.ISA_CP_FAV_ALT_DSC ? order.ISA_CP_FAV_ALT_DSC.trim().length > 36 ? order.ISA_CP_FAV_ALT_DSC.substr(0, 36) + "..." : order.ISA_CP_FAV_ALT_DSC : ""}</td>*/}
    //                            {/*<td className="d-none d-sm-none d-md-table-cell">{order.BUSINESS_UNIT}</td>
    //                <td className="d-none d-sm-none d-md-table-cell priority-alert">{order.ISA_PRIORITY_FLAG == `R` ? `Priority` : ``}</td>
    //                <td className="d-none d-sm-none d-md-table-cell">{order.OPRID_ENTERED_BY}</td>
    //                <td className="d-none d-sm-none d-md-table-cell">{order.ORDERED_FOR}</td>
    //                <td className="text-center"><a href="#" className="delete-icon-custom float-none d-inline-block" data-toggle="modal" data-target="#Cancel-confirmation" data-backdrop="static" data-keyboard="false" onClick={(e) => this.handleDelete(order.FAV_ORDER_ID)} /></td>*/}
    //                        </tr>
    //                        <tr className="p d-none" id={`contentrow-${index}`}>
    //                            <td colSpan="13" className="hiddenRow" id="order-row-1">
    //                                <div className="py-1" id={`order-row-${index}`}>
    //                                    <div className="col-md-12 float-left mx-0 mobile-fieldscontainer item-box py-3">
    //                                        <div className="col-12 p-0">
    //                                            <div className="col-12 mobile-fields p-0">
    //                                                <label className="catalog-label"><Trans>Category</Trans><span> </span><span>:</span></label>
    //                                                <label className="item-details-value">{order.ISA_FAVS_CATEGORY}</label>
    //                                            </div>

    //                                            {/*<div className="col-12 mobile-fields p-0">
    //                                                <label className="catalog-label"><Trans>Description</Trans><span>:</span></label>
    //                                                <label className="item-details-value">{order.ISA_CP_FAV_ALT_DSC}</label>
    //                                            </div>*/}

    //                                        </div>
    //                                    </div>
    //                                    {orderLineItemCount > 0 ? <React.Fragment>
    //                                        <h4 className="item-details-title float-left"><Trans>Item</Trans><span> </span><Trans>Details</Trans></h4>
    //                                        {this.bindFavOrderLineItems(order.ISA_FAVS_CATEGORY)}

    //                                        {/*<div className="col-md-12 float-right p-0 mx-0">
    //                                            <div className="col-md-12  d-none">
    //                                                <div className="float-right total-order">
    //                                                    Order Total <span className="price-rate">$8.4352</span>
    //                                                </div>
    //                                            </div>
    //                                            <div className="col-md-12 float-right p-0 my-3">
    //                                                <button className="btn btn-primary custom-btn-primary primary-btn float-right px-5" onClick={() => this.addFavOrderItemsToCart(order.ORDER_NO)}>Reorder</button>
    //                                            </div>
    //                                        </div>*/}
    //                                    </React.Fragment> : `No line items are present in this order`}
    //                                </div>
    //                            </td>
    //                        </tr>
    //                    </React.Fragment>
    //                );
    //            }
    //        })
    //    }
    //}
    //WAL-541_PC_19
    bindFavOrderLineItems = (index, order) => {
        
        // let childItems = this.state.favOrderLineItemData.filter((item, index) => item.ORDER_NO == OrderNo);
        //console.log("childItems", childItems)
        return this.state.GridArr.map((childItem, childindex) => {
            if (childItem.ISA_FAVS_CATEGORY == order.ISA_FAVS_CATEGORY && childItem.ISA_FAVS_SUBCATEGORY == order.ISA_FAVS_SUBCATEGORY) {
                let RecSuppStr = "";
                let supplierstr = "";
                let valitemdesc = childItem.DESCR254;
                const descexpand = {
                    //previewHeight: "88px",
                    // expandText: "Read more",
                    value: childItem.ISA_CP_FAV_ALT_DSC
                };
                const TEXT_COLLAPSE_OPTIONS = {
                    collapse: false, // default state when component rendered
                    collapseText: '... show more', // text to show when collapsed
                    expandText: 'show less', // text to show when expanded
                    minHeight: 100, // component height when closed
                    maxHeight: 250 // expanded to
                }


                let imagePath = "";
                let noimg = false;
                if (childItem.IMAGE_NAME == "Images\noimage_new.png") {
                    imagePath = `/Images/noimage_new.png`;
                }
                else if (childItem.IMAGE_NAME) {
                    childItem.IMAGE_NAME = childItem.IMAGE_NAME.replace('\\', '/');
                    
                    if (childItem.IMAGE_NAME.toLowerCase().indexOf("http") >= 0) {

                        imagePath = childItem.IMAGE_NAME;
                    } else {
                        imagePath = childItem.IMAGE_NAME.lastIndexOf(`/`) >= 0 ? childItem.IMAGE_NAME.substring(childItem.IMAGE_NAME.lastIndexOf("/") + 1, childItem.IMAGE_NAME.length) : "noimage_new.png";
                        if (imagePath) {
                            imagePath = `/Images/noimage_new.png`;
                            noimg = true;

                        }
                    }
                }

                else {
                    imagePath = `/Images/noimage_new.png`;

                }
                if (childItem.ITEM_DESC != null || childItem.ITEM_DESC != undefined) {
                    childItem.ITEM_DESC = childItem.ITEM_DESC.includes("&apos;") ? childItem.ITEM_DESC.replaceAll("&apos;", "'") : childItem.ITEM_DESC; //BUG-2628 (9/9/2022)-Aparna
                }
                let desc = ""
                if (childItem.ISA_CP_FAV_ALT_DSC != null && childItem.ISA_CP_FAV_ALT_DSC != undefined) {
                    if (childItem.ISA_CP_FAV_ALT_DSC.trim() != "") {
                        desc = childItem.ISA_CP_FAV_ALT_DSC.length > 50 ? childItem.ISA_CP_FAV_ALT_DSC.substr(0, 36) : childItem.ISA_CP_FAV_ALT_DSC
                    }
                }
                let notesboolean = false;
                if (childItem.ISA_CP_FAV_ALT_DSC != null && childItem.ISA_CP_FAV_ALT_DSC != undefined) {
                    if (childItem.ISA_CP_FAV_ALT_DSC.trim() != "") {
                        notesboolean = true
                    }
                }
                let IsCoreCheck = false
                // WW-685 PC_685_02 Display label for unavaialable item 5/26/2023 Pavithra R

                //WW-516_FI_PC_05 (10/14/2022)-Aparna K
                //[1/25/23, WW-542_PC_27, Dhevanesam R]
                return (

                    <div className="row mx-0 mb-3 p-3 item-box align-items-center">
                        <div className="col-lg-2 col-md-5 mb-2">
                            {/* {noimg == true ? <img className="sdi-category-image" src={imagePath} alt="favorite icon" onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": "96%" }} onClick={(e) => this.showitemdetails(childindex, childItem.ISA_CP_ITEM_ID, childItem.MANUFACTURER, childItem.CLIENT_MFG_PART, childItem.SUPPLIER_ID, e, childItem)}  /> :
                                <img className="sdi-category-image" src={imagePath} alt="favorite icon" onError={(e) => { e.target.src = "/Images/noimage_new.png" }} style={{ "width": "96%" }} />}*/}
                            <div className=" w-100 order-summary-image category-search-image-height favitem-image-size" >
                                <div className="w-100 custom-fav-image pr-0 Image-ShoppingCart" onClick={(e) => this.showitemdetails(childindex, childItem.ISA_CP_ITEM_ID, childItem.MANUFACTURER, childItem.CLIENT_MFG_PART, childItem.SUPPLIER_ID, e, childItem)} >
                                    <Image
                                        id={`Img${order.ORDER_NO}${index}id`}
                                        src={imagePath}
                                        width={125}
                                        height={100}
                                        overflow="hidden"
                                        alignItems="center"
                                        accept="image/x-png,image/gif,image/jpeg"
                                        style={style.image}
                                        noImageSrc="/Images/noimage_new.png"
                                        position="auto"
                                    />
                                </div>
                            </div>
                            {/*<img src={imagePath} alt="fav_item" onClick={() => this.showitemdetails(indexval, val.clientPartNumber, val.ItemAttributeId, FavItem)} />*/}

                            {/*<div className="d-flex justify-content-center">
                                        <div className="sdi-edit-bg">
                                            <input type="file"  style={{ display: 'none' }} id={`Item-${childindex}`} name="" checked={true} onChange={e => this.HandleOnChange(e, "FirstPOOnly")} />
                                            <label htmlFor={`Item-${childindex}`} className="sdi-edit-label mb-0"><span><img src="images/edit-icon.svg" id="image" className="mb-1 sdi-edit-icon-width" /></span> Edit</label>
                                        </div>
                                    </div>*/}
                        </div>
                        <div className="col-lg-10 col-md-12">
                            <div className="row align-items-center">
                                {/*<div className="col-md-12 fav-maintence mb-3">
                                            <div className="row">
                                                <label className="catalog-label col-md-12 col-lg-2 w-100"><Trans>Description</Trans><span> :</span></label>
                                                <div className="col-md-12 col-lg-10">
                                                    <label className="item-details-value w-100">{valitemdesc}</label>
                                                </div>
                                            </div>
                                        </div>*/}
                                <div className="col-md-12 col-lg-5">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="catalog-label w-100"><Trans>Item</Trans><span> </span><Trans>ID</Trans><span> :</span></label>
                                        </div>
                                        <div className="col-md-8">
                                            {/*[1/20/23, WW-542_PC_20, Dhevanesam R]*/}
                                            <a href className="item-details-value" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.showitemdetails(childindex, childItem.ISA_CP_ITEM_ID, childItem.MANUFACTURER, childItem.CLIENT_MFG_PART, childItem.SUPPLIER_ID, e, childItem)}>{childItem.CLIENT_MFG_PART}</a>


                                            {childItem.hasBenItemVal == "C" ? <span class="i-circlegridBlue">C</span> : childItem.hasBenItemVal == "T" ? <span class="i-circlegridYellow">T</span> : childItem.SUPPLIER_ID == "W999999999" || childItem.SUPPLIER == "SDI Warehouse" ? <span class="i-circlegrid">w</span> : null}

                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12 col-lg-5">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="catalog-label w-100"><Trans>Manufacturer</Trans><span>:</span></label>
                                        </div>
                                        <div className="col-md-8">
                                            <label className="item-details-value textbreakwrap">{childItem.MANUFACTURER != " " ? childItem.MANUFACTURER : `-`}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-5">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="catalog-label w-100">Description:</label>
                                        </div>
                                        <div className="col-md-8">
                                            <label className="item-details-value textbreakwrap">{childItem.ITEM_DESC ? childItem.ITEM_DESC : ``}</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12 col-lg-5">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="catalog-label w-100">Supplier:</label>
                                        </div>
                                        <div className="col-md-8">
                                            <label className="item-details-value textbreakwrap">{childItem.SUPPLIER_NAME}</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12 col-lg-5">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="catalog-label w-100">UOM:</label>
                                        </div>
                                        <div className="col-md-8">
                                            <label className="item-details-value">{childItem.UNIT_OF_MEASURE}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-5">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="catalog-label w-100"><Trans>Share</Trans>/<Trans>Delete</Trans><span>:</span></label>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="custom-control custom-checkbox item-custom-control m-0">
                                                <input type="checkbox" className="custom-control-input" checked={childItem.checked} id={`EditItem-${childindex}`} name="check" onChange={() => this.CategoryOnCheck("Item", childItem)} />
                                                <label className="custom-control-label" htmlFor={`EditItem-${childindex}`} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-5">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="catalog-label w-100"><span>Supplier </span><Trans>part#</Trans><span>:</span></label>
                                        </div>
                                        <div className="col-md-8"> {/*18/10/23, PC_WW_850_02 - To expand and collapse the Description, Vishwa S]*/}
                                            <label className="item-details-value textbreakwrap">{childItem.ISA_CP_ITEM_ID != "" && childItem.ISA_CP_ITEM_ID != " " && childItem.ISA_CP_ITEM_ID != null ? childItem.ISA_CP_ITEM_ID.length > 15 && !this.state.IsDotClickIndex.includes(childindex) ?
                                                <React.Fragment><span className="item-details-value searchSupplierwidth">{`${childItem.ISA_CP_ITEM_ID.substring(0, 15)}`}</span>
                                                    <span className="expand-collapse-style text-nowrap" onClick={(e) => this.handleDotclick(childindex, 'More')} >...More</span> </React.Fragment>
                                                : childItem.ISA_CP_ITEM_ID.length > 15 ? <React.Fragment> <span className="item-details-value searchSupplierwidth">{`${childItem.ISA_CP_ITEM_ID}`}</span> <span className="expand-collapse-style text-nowrap" onClick={(e) => this.handleDotclick(childindex, 'Less')} > Less</span> </React.Fragment> : <span className="item-details-value searchSupplierwidth">{`${childItem.ISA_CP_ITEM_ID}`}</span>
                                                : `-`}</label>
                                        </div>
                                    </div>
                                </div>
                                {notesboolean ? <div className="col-md-12 col-lg-5">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="catalog-label w-100" >Notes:</label>
                                        </div>
                                        <div className="col-md-8">
                                            {childItem.ISA_CP_FAV_ALT_DSC.length > 100 ? <ShowMoreText
                                                /* Default options */
                                                lines={1}
                                                /*more=".."*/
                                                less="Show less"
                                                /* anchorClass="oooeeer"*/
                                                /*  onClick={this.executeOnClick}*/
                                                expanded={false}
                                                keepNewLines={false}
                                                width={0}
                                                className={'d-inline ml-2 sdi-notes item-details-value'}
                                            >
                                                {childItem.ISA_CP_FAV_ALT_DSC}
                                            </ShowMoreText> : <label id={`yourdescval-${childindex}`} className="item-details-value" style={{ wordBreak: 'break-all' }} >{childItem.ISA_CP_FAV_ALT_DSC ? childItem.ISA_CP_FAV_ALT_DSC : ``}</label>}
                                            {/*<label className="item-details-value">Ad</label>*/}
                                        </div>
                                    </div>
                                </div> : null}
                                <div className="col-lg-12 col-md-12 text-right Ipad-UI fav-maintence my-3">
                                    {childItem.InvItemQtyCheck == false ? <a className="m-1"><img src="images/Shopping Cart.svg" alt="shoppingcart" className={childItem.ISA_CATALOG_FLAG == "NA" ? "disablecart sdi-width-30px" : "sdi-width-30px"} onClick={(e) => this.Addtocart(e, childItem, childindex, IsCoreCheck)} /></a> : null}
                                    <a className="pointercursor" style={{ cursor: 'pointer' }}><img src="images/delete.svg" alt="delete" className="sdi-width-20px" data-toggle="modal" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#Cancel-confirmation" onClick={(e) => this.DeleteFav(e, childItem)} /></a>
                                    <a className="ml-2 pointercursor" style={{ cursor: 'pointer' }}><img src="images/edit-icon.svg" alt="editicon" data-backdrop="static" data-keyboard="false" onClick={(e) => this.EditFav(childItem, "No")} /></a>
                                    <a className="ml-2"><img src="images/share.jpg" alt="share" className="sdi-width-30px" data-toggle="modal" data-target="#Fav_Item_Sharing" data-backdrop="static" data-keyboard="false" onClick={(e) => this.SharedIconClick(childItem, "order", "")} /></a>
                                </div>
                                <div className="col-md-12  float-right">
                                    {childItem.ISA_COMMENTS != "" && childItem.ISA_COMMENTS != " " && childItem.ISA_COMMENTS != null && childItem.ISA_COMMENTS != undefined ?
                                        <p className="float-right alpart-label mt-2">  <img src="/Images/caution.svg" className="fav-popover-alert-img" alt="Fav-Img" />
                                            {childItem.ISA_COMMENTS} </p> : null}
                                </div>
                            </div>
                        </div>
                    </div>


                )
            }
        })
    }
    //WAL-714_PC_06 -Aparna updateion(3/29/2022)
    SharedIconClick = (obj, level, catname) => {
        let CatShare = [];
        this.setState({ SharedItem: obj });

    }
    //WAL-714_PC

    //WAL-714_PC_07 -Aparna
    HandleOnChange = (event, name, index) => {
        switch (name) {
            case "SelectedRegion": {
                let emp = []
                if (event != null) {
                    this.state.EMPDD.map((val, index) => {
                        if (event.value == val.REGION) {
                            if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                                let localArray = {
                                    value: val.EMP_ID,
                                    label: val.ISA_EMPLOYEE_NAME + " " + val.ISA_EMPLOYEE_EMAIL
                                }

                                emp.push(localArray)
                            }
                        }

                    });
                }
                // WAL -714_PC_UserDD_01
                else {
                    this.state.EMPDD.map((val, index) => {
                        if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                            let localArray = {
                                value: val.EMP_ID,
                                label: val.ISA_EMPLOYEE_NAME + " " + val.ISA_EMPLOYEE_EMAIL
                            }

                            emp.push(localArray)
                        }
                    });
                }

                this.setState({ [name]: event, UserDD: emp, SelectedUser: [] });
                break;
            }
            case "SelectedUser": {
                let selectedPC = [];
                let selectedpclength = this.state.UserDD.length
                let pclenght = this.state.UserDD
                let eventlength = event.lastIndexOf()

                event.forEach((val, ind) => {
                    if (event[ind].value == "*") {

                        selectedPC = []
                        this.state.UserDD.forEach((x, i) => {

                            //let localArray = {
                            //    value: x.value,
                            //    label: x.ISA_PROBLEM_CODE
                            //}
                            selectedPC.push(x);

                        })
                        return true;
                    }
                    else {
                        selectedPC.push(val);
                    }


                })
                this.setState({ SelectedUser: selectedPC });
                break;
            }


        }
    }
    //WAL-714_PC_09
    ShareButtonClick = () => {
        let empids = []
        let shareorderdetail = []
        this.state.SelectedUser.forEach((x) => {
            empids.push(x.value)
        })
        if (empids.length > 0) {


            let filteritem = []
            filteritem = this.state.GridArr.filter((x) => x.checked == true)
            if (this.state.SharedItem.ISA_CP_ITEM_ID != null) {
                shareorderdetail = this.state.GridArr.filter((x) => x.ISA_CP_ITEM_ID == this.state.SharedItem.ISA_CP_ITEM_ID)

            }
            else {
                shareorderdetail = filteritem
            }



            console.log("shareorderdetail", empids);
            console.log("SelectedUser", shareorderdetail);
            let NewFavItem = [];
            //let Kitcomponents = shareorderdetail[i].ISA_KIT_COMPONENTS


            shareorderdetail.forEach((x, i) => {
                let core = false;
                if (shareorderdetail[i].CORECHARGES == "CORE") {
                    core = true

                }
                NewFavItem.push({
                    ItemId: shareorderdetail[i].ISA_CP_ITEM_ID,
                    YourCat: shareorderdetail[i].ISA_FAVS_CATEGORY,
                    YourSubCat: shareorderdetail[i].ISA_FAVS_SUBCATEGORY,
                    YourDesc: shareorderdetail[i].ISA_CP_FAV_ALT_DSC,
                    Notes: "",
                    Isa_Catalog_Flag: shareorderdetail[i].ISA_CATALOG_FLAG,
                    ISA_COMMENTS: shareorderdetail[i].ISA_COMMENTS,//PC_WAL-1100_08-Adding a column-comments
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                    Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                    Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                    Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                    Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                    Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                    Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                    Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                    Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                    SDI_Catagory: shareorderdetail[i].ITEM_CATEGORY,
                    ManufacturerPartNo: shareorderdetail[i].CLIENT_MFG_PART,
                    //SAP: this.state.NewItem[0].customer_part_number_woprefix != "\N" && this.state.NewItem[0].customer_part_number_woprefix.trim() != "" && this.state.NewItem[0].customer_part_number_woprefix.trim() != null && this.state.NewItem[0].customer_part_number_woprefix.trim() != undefined ? this.state.NewItem[0].customer_part_number_woprefix : " ",
                    //[12/9/21, PC_FI_01, Bug - 1866, Dhevanesam R]
                    SupplierID: shareorderdetail[i].SUPPLIER_ID,
                    Manufacturer: shareorderdetail[i].MANUFACTURER,
                    Price: "",
                    SDI_Description: shareorderdetail[i].ITEM_DESC,
                    UOM: shareorderdetail[i].UNIT_OF_MEASURE,
                    ImgByteCode: shareorderdetail[i].IMAGE_NAME,
                    Kit_Components: shareorderdetail[i].ISA_KIT_COMPONENTS,
                    ISCoreCharge: core,

                })
            })
            let BO = {
                FavItems: NewFavItem,
                EmplIDs: empids
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            FavItemMainAction.ShareItemButtonClickAction(BO);
        } else {
            document.getElementById('usererror').innerHTML = "Please select user"
        }
    }
    //WAL-714_PC_12 -Aparna
    ShareItemButtonClickResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: "Shared Successfully"
        });
        // alert("shared successfully");
        $('#Fav_Item_Sharing').modal('hide');
        let locEMP = [];
        this.state.EMPDD.forEach((val, index) => {
            if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                let localArray = {
                    value: val.EMP_ID,
                    label: val.ISA_EMPLOYEE_NAME + " " + val.ISA_EMPLOYEE_EMAIL
                }

                locEMP.push(localArray)
            }
        });
        document.getElementById('usererror').innerHTML = ""
        //[1/20/23, WW-542_PC_19, Dhevanesam R]
        let srtxt = ""
        if (searchTxt != "") {
            srtxt = $(`#searchTxt`).val().toLowerCase();
        }
        this.favPageLoad("1", this.state.RecCount, srtxt, searchCol, "ISA_FAVS_CATEGORY", this.state.SortingVal)
        //window.location.reload(true)
        this.setState({ SelectedUser: [], SelectedRegion: [], UserDD: locEMP, SharedItem: [] })
        let Response = JSON.parse(FavItemMainStore.pageLoadData);
        console.log("share resposne", Response);



    }
    //WAL-714_PC_13
    Fav_Order_Share_Close = () => {
        let locEMP = [];
        this.state.EMPDD.forEach((val, index) => {
            if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                let localArray = {
                    value: val.EMP_ID,
                    label: val.ISA_EMPLOYEE_NAME + " " + val.ISA_EMPLOYEE_EMAIL
                }

                locEMP.push(localArray)
            }
        });
        document.getElementById('usererror').innerHTML = ""
        this.setState({ SelectedRegion: [], SelectedUser: [], UserDD: locEMP, CategoryShare: [] });
    }
    //WAL-714 update
    ShareMultipleItems = () => {
        let filteritem = this.state.GridArr.filter((x) => x.checked == true)
        if (filteritem.length > 0) {
            $('#Fav_Item_Sharing').modal('show');
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select any category / items"
            });
            //   alert("Select any category / items");
        }

    }
    //WW-419_PC-02 (5/25/2022) -Aparna
    DeleteButtonClick = (e) => {
      
        let lineItem = this.state.GridArr.filter((x) => x.checked == true);
        if (lineItem.length > 0) {
            e.preventDefault();
            $('#Cancel-confirmation').modal('show');
            this.setState({ multiDelete: true });
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Select Any Item To Delete"
            });
            // alert("Please Select Any Item To Delete");
        }

    }
    //WW-419_PC-04 (5/25/2022) -Aparna
    DeleteMultipleItem = () => {
        let lineItem = this.state.GridArr.filter((x) => x.checked == true)
        let favItemUpdate = [];
        if (lineItem.length > 0) {

            lineItem.forEach((x) => {
                let loc = {
                    ItemId: x.ISA_CP_ITEM_ID,
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                    MFG: x.MANUFACTURER,
                    MFGpartnum: x.CLIENT_MFG_PART,
                    SupplierId: x.SUPPLIER_ID,
                    ISA_CATALOG_FLAG: x.ISA_CATALOG_FLAG,
                    ISA_COMMENTS: x.ISA_COMMENTS,
                    isFromFav: true,
                }
                favItemUpdate.push(loc)

            })
            let BO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Items: favItemUpdate,
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            FavItemMainAction.DeleteButtonClickAction(BO);

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select any item"
            });
            //  alert("Select any item");
        }
    }
    //WW-419_PC_10 
    DeleteMultipleItemResponse() {


        let response = FavItemMainStore.deleteresponse

        if (response == "success") {
            MenuAction.refreshMasterData();
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Deleted successfully"
            });
            //  alert("Deleted successfully")
            let srtxt = ""
            if (searchTxt != "") {
                srtxt = $(`#searchTxt`).val().trim();
            }
            console.log("SortingVal", this.state.SortingVal)
            this.favPageLoad("1", this.state.RecCount, srtxt, searchCol, "ISA_FAVS_CATEGORY", this.state.SortingVal)
            this.setState({ multiDelete: false });

            //window.location.reload(true)
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "please try again"
            });
            //  alert("please try again");
        }
        //WW-757-Commenting hide of the loader as we hide in pageload response
        // $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //WW-419_PC_19 adding select all and unselect all functionality(6/8/2022) -Aparna
    SelectAllButtonClick = (e, SelectAll) => {
        let { GridArr } = this.state;
        let { CategoryArr } = this.state;
        let { SubCategoryArr } = this.state;
        if (SelectAll) {
            GridArr.forEach((x, i) => {
                this.state.GridArr[i].checked = true
            })
            CategoryArr.forEach((x, i) => {
                this.state.CategoryArr[i].check = true
            })
            SubCategoryArr.forEach((x, i) => {
                this.state.SubCategoryArr[i].SubCatcheck = true
            })
        }
        else {
            GridArr.forEach((x, i) => {
                this.state.GridArr[i].checked = false
            })
            CategoryArr.forEach((x, i) => {
                this.state.CategoryArr[i].check = false
            })
            SubCategoryArr.forEach((x, i) => {
                this.state.SubCategoryArr[i].SubCatcheck = false
            })
        }
        this.setState({ GridArr });
        this.setState({ CategoryArr });
        this.setState({ SubCategoryArr });
        this.setState({ SelectAll: this.state.SelectAll ? false : true });
    }
    //WW-516_FI_PC_01 (10/14/2022)-Aparna
    SelectSubCategory = (event, cat, index, catItem) => {
        //if (event != "pageLoad") {
        //event.stopPropagation()
        //}

        //$(`#Category-${index}`).addClass('sdi-category-header-active')
        //if (this.state.SelectedCatIndex != index) {
        //    $(`#Category-${this.state.SelectedCatIndex}`).removeClass('sdi-category-header-active')
        //}
        
        if (event == "pageLoad") {
            $(`#Category-${this.state.SelectedCatIndex}`).removeClass('sdi-category-header-active')
            $(`.sdi-category-header-active`).removeClass('sdi-category-header-active')
            //WW-542_PC_06 (12/1/2022)-Aparna
            $(`#Category-${index}`).addClass('sdi-category-header-active')
        }
        else {
            $(`.sdi-category-header-active`).removeClass('sdi-category-header-active')
            $(`#Category-${index}`).addClass('sdi-category-header-active')
            if (this.state.SelectedCatIndex != index) {
                $(`#Category-${this.state.SelectedCatIndex}`).removeClass('sdi-category-header-active')
            }
        }
        let locsubcat = []
        let filteredSubCat = []
        let count = 0
        locsubcat = this.state.GridArr.filter((val, ind) => val.ISA_FAVS_CATEGORY == cat)
        filteredSubCat = locsubcat.filter((v, i, a) => a.findIndex(t => (t.ISA_FAVS_SUBCATEGORY === v.ISA_FAVS_SUBCATEGORY)) === i)
        if (filteredSubCat.length > 0) {
            count = filteredSubCat.length;
        }
        let countT = parseFloat(count) / 10
        this.setState({ SelectedCategory: cat, SelectedCatIndex: index, SubCategoryArr: filteredSubCat, TotalCount: count, pageCount: countT, PageNo: 1 });
        if (catItem.check) {
            if (filteredSubCat != [] && filteredSubCat != undefined && filteredSubCat != null) {
                filteredSubCat.forEach((x, index) => {
                    if (x.ORDER_CATEGORY == catItem.ORDER_CATEGORY) {
                        filteredSubCat[index].SubCatcheck = true
                    }
                })
                this.setState({ SubCategoryArr: filteredSubCat });
            }
            //this.CategoryOnCheck("SubCat",cat)
        }
        else {
            if (filteredSubCat != [] && filteredSubCat != undefined && filteredSubCat != null) {
                filteredSubCat.forEach((x, index) => {
                    if (x.ORDER_CATEGORY == catItem.ORDER_CATEGORY) {
                        filteredSubCat[index].SubCatcheck = false
                    }
                })
                this.setState({ SubCategoryArr: filteredSubCat });
            }
        }
        // this.setState({ SelectedCategory: cat, SelectedCatIndex: index });

    }
    //WW-516_FI_PC_02 (10/14/2022)-Aparna
    bindCategory = () => {


        return this.state.CategoryArr.map((order, index) => {
            // if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {

            let cat = order.ORDER_CATEGORY
            return (
                <React.Fragment key={order.ISA_FAVS_CATEGORY}>

                    <li>
                        <div className="card-header sdi-category-header mb-2" id={`Category-${index}`} onClick={e => this.SelectSubCategory("", order.ISA_FAVS_CATEGORY, index, order)}>
                            <div className="d-flex justify-content-between " style={{ "word-break": "break-all" }}>{order.ISA_FAVS_CATEGORY == "" || order.ISA_FAVS_CATEGORY == " " ? "Unclassified" : order.ISA_FAVS_CATEGORY}
                                <div className="d-flex justify-content-between" ><input type="checkbox" className="sdi-checkbox" id={`Categorycheckbox-${index}`} name="" checked={order.check} onChange={e => this.CategoryOnCheck("cat", order, index)} />
                                </div>
                            </div>
                        </div>
                    </li>

                </React.Fragment>

            )

            //  }

        });

    }
    bindCategoryMob = () => {


        return this.state.CategoryArr.map((order, index) => {
            // if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {

            let cat = order.ORDER_CATEGORY
            return (

                <option value={order.ISA_FAVS_CATEGORY}>{order.ISA_FAVS_CATEGORY}</option>


            )

            //  }

        });

    }

    /*18/10/23, PC_WW_850_03 - To expand and collapse the Description, Vishwa S]*/
    handleDotclick = (ItemIndex, Action) => {
        if (Action === "More") {
            this.state.IsDotClickIndex.push(ItemIndex)
            this.setState({ IsDotClick: true })
        }
        else if (Action === "Less") {
            let index = this.state.IsDotClickIndex.indexOf(ItemIndex);

            if (index !== -1) {
                this.state.IsDotClickIndex.splice(index, 1);
                this.setState({ IsDotClick: true })
            }
        }
    }

    mobcatchange = (event) => {
        this.SelectSubCategory(event, event.target.value, 0)
    }
    //WW-516_FI_PC_03 (10/14/2022)-Aparna K
    bindSubCategory = () => {
        //let cat = "";
        return this.state.SubCategoryArr.map((order, index) => {
            if (index < parseInt(this.state.PageNo) * 10 && index >= parseInt(this.state.PageNo - 1) * 10) {
                console.log("this.state.CategoryArr", this.state.SubCategoryArr)
                // if (order.ISA_FAVS_CATEGORY == this.state.SelectedCategory) {
                return (
                    <React.Fragment>
                        <tr>
                            <td data-toggle="collapse" className="accordion-toggle" id={`accordian${index}`} data-target={`#contentrowI${index}-${index}`} aria-controls={`#contentrowI${index}-${index}`} onClick={(e) => this.onAccordianClick(e, index)}>
                                <span className="accordion-arrow" id={`arrowI-${index}`} />
                            </td>
                            <td><h4 className="font-20 mb-0 sdi-category-title">{order.ISA_FAVS_SUBCATEGORY}</h4></td>
                            <td>
                                <div className="d-flex align-items-center"><label className="sdi-category-title mr-2 mb-0">Share/Delete </label>
                                    <div className="custom-control custom-checkbox item-custom-control mb-2">
                                        <input type="checkbox" className="custom-control-input" id={`SubCategory-${index}`} name="" checked={order.SubCatcheck} onChange={(e) => this.CategoryOnCheck("SubCat", order)} />
                                        <label className="custom-control-label" htmlFor={`SubCategory-${index}`} />
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr className="accordian-body collapse py-1" id={`contentrowI${index}-${index}`}>
                            <td colSpan={12} className="pl-5 pr-0 py-4">
                                {/* 1st level accordion - Starts here */}
                                <h4 className="item-details-title-fmt">Item details</h4>
                                {this.bindFavOrderLineItems(index, order)}
                            </td>
                        </tr>
                    </React.Fragment>
                )
                //}
            }
        });
    }
    render() {

        return (
            <React.Fragment>
                <div className="container-fluid content-section content-margin">
                    <div className="row">
                        {/* Title - Starts here */}
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title">Favorite Item Maintenance</h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-1">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        {/* Title - Ends here */}

                        <div className="col-md-12">
                            <div className="row float-right align-items-center px-3 mb-3">
                                {this.state.totalCount == 0 && isPostBack == true ? null : <div className="input-group dropdown-search mr-2 mb-2">
                                    <div className="input-group-prepend">
                                        <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><Trans>{this.state.filterDisplayName}</Trans></button>
                                        <div className="dropdown-menu" style={{}}>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "All", "ALL")}><Trans>All</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Supplier Part#", "ISA_CP_ITEM_ID")}><Trans>Supplier Part#</Trans> </a>
                                            {/* <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "SDI Category" , "ITEM_CATEGORY")}><span>SDI  </span><Trans>Category</Trans></a>*/} {/*14/08/2023, 3816 - commented the SDI category in drop down , Divis Kumar R K*/}
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Category", "ISA_FAVS_CATEGORY")}><Trans>Category</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Sub Category", "ISA_FAVS_SUBCATEGORY")}><Trans>Sub Category</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Item Description", "ITEM_DESC")}><Trans>Item</Trans><span> </span><Trans>Description</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Notes", "ISA_CP_FAV_ALT_DSC")}><Trans>Notes</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "MFG", "MANUFACTURER")}>MFG</a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "MFG Part Number", "CLIENT_MFG_PART")}><span>MFG  </span><Trans>Part Number</Trans></a>
                                        </div>
                                    </div>
                                    <input type="text" className="form-control" placeholder="Search" aria-label="Text input with dropdown button" id="searchTxt" onKeyDown={this.AnykeyPress} />
                                    <span className="dropdown-search-icon" onClick={this.handleSearch} />
                                </div>}
                                {this.state.totalCount != 0 ?
                                    <div>

                                        <button type="button" className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.DeleteButtonClick(event)}>
                                            <Trans>Delete</Trans></button>
                                        <button type="button" className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.ShareMultipleItems()}>
                                            <Trans>Share</Trans></button>
                                        {/*<button type="button" className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add-fav-popup" onClick={this.AddNewFav}>
                                    <span className="btn-label"><span className="add-new-icon" /></span><Trans>New</Trans></button>*/}
                                        {/*//[6/7/2023], WW-722, LABEL CHANGE PAVITHRA R*/}
                                        {/*<button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add-fav-popup" onClick={this.AddNewFav}><span><img src="../images/add-new-icon.png" alt="addicon" className="sdi-plus-style" /></span><trans>New</trans></button>*/}
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.RedirectTo(event, "/shoppingcart")}><span><img src="../images/item_cart.png" alt="shoppingicon" className="sdi-plus-style" /></span><Trans>Return to</Trans><span> </span><Trans>shopping cart</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.RedirectTo(event, "/homepage")}><span><img src="../images/shopping-bag.png" alt="bagicon" className="sdi-plus-style" /></span><Trans>Continue shopping</Trans></button>

                                        {/*<button type="button" className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.RedirectTo(event, "/shoppingcart")}>
                                <span className="btn-label"><span className="item-cart" /></span><Trans>Return to</Trans><span> </span><Trans>Shopping Cart</Trans></button>
                            <button type="button" className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.RedirectTo(event, "/homepage")}>
                                <span className="btn-label"><span className="shopping-bag" /></span><Trans>Continue Shopping</Trans></button>*/}
                                        <button type="button" className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.SelectAllButtonClick(event, this.state.SelectAll)}>
                                            {this.state.SelectAll ? <Trans>Select All</Trans> : <Trans>UnSelectAll</Trans>}</button></div> : null}
                            </div>

                            {this.state.totalCount != 0 ? <div className="row mb-3">
                                <div className="d-md-none d-lg-none d-sm-block col-md-3">
                                    <label className="sdi-category-title">Select Category</label>
                                    <select className="sdi-category-dropdown form-control" value={this.state.SelectedCategory} onChange={e => this.mobcatchange(e)}>
                                        {this.bindCategoryMob()}


                                    </select>
                                </div>
                            </div> : null}
                        </div>
                        {this.state.totalCount != 0 ?
                            <div className="col-md-12">
                                <div className="col-md-12">
                                    <div className=" text-center ">
                                        <span style={{ fontSize: "15px" }}>Cart items quantity will be updated when it is already available in the cart</span>
                                    </div>
                                </div>
                            </div> : null}
                        {this.state.totalCount != 0 ?
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-sm-4 col-md-4 col-lg-3 my-3 mobile-filter">
                                        <div id="accordion" className="accordion-container filters-search">
                                            <div className="sdi-fav-category-container filters-search">
                                                <h6 className="accordion-title mb-0">Category</h6>

                                                <ul className="card border-0 list-unstyled sdi-container-padding AG-category-scroll">
                                                    {this.state.GridArr.length > 0 ? this.bindCategory() : null}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 col-md-8 col-lg-9 mt-3">
                                        <div className="row px-3">
                                            <div className="w-100 sdi-outerframe-style">
                                                <div className="col-md-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-lg-6 mb-2">
                                                            {/* popup category */}
                                                            <span className="float-right mb-3 d-none">
                                                                <a href="#" className="mt-2 mx-2 category-icon-toggle">
                                                                    <img src="images/category-icon.svg" alt="category Icon" className="sdi-category-icon-width" />
                                                                </a>
                                                            </span>
                                                            {/* popup category */}
                                                            <label className="search-category title-font m-0">Selected category :</label>
                                                            <span className="list-count ml-2">{this.state.SelectedCategory}</span>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="d-flex justify-content-end">
                                                                {this.state.totalCount > 0 ? <>

                                                                    <div className="col-md-12">

                                                                        {this.state.pageCount > 1  ? <ReactPaginate
                                                                            previousLabel={<span className="right-pagination-arrow" />}
                                                                            nextLabel={<span className="left-pagination-arrow" />}
                                                                            previousClassName={'page-item'}
                                                                            nextClassName={'page-item'}
                                                                            previousLinkClassName={'page-link'}
                                                                            nextLinkClassName={'page-link'}
                                                                            disabledClassName={'disabled'}
                                                                            breakLabel={'...'}
                                                                            breakClassName={'page-item'}
                                                                            breakLinkClassName={'page-link'}
                                                                            pageCount={this.state.pageCount}
                                                                            marginPagesDisplayed={1}
                                                                            pageRangeDisplayed={2}
                                                                            onPageChange={this.handlePageClick}
                                                                            containerClassName={'custom-pagination pagination float-right'}
                                                                            pageClassName={'page-item'}
                                                                            pageLinkClassName={'page-link'}
                                                                            activeClassName={'active'}
                                                                            hrefBuilder={() => '#'}
                                                                            forcePage={this.state.PageNo - 1}
                                                                        /> : null}
                                                                    </div></> : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="table-responsive">
                                                        <table className="table ZEUS_Grid sdi-FOM-grid mobileresponsive-grid">
                                                            <tbody>
                                                                {this.state.SelectedCategory != "" ? this.bindSubCategory() : null}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            (<section className="site-undercontruction container text-center center-panel-1">
                                <div className="img-section">
                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                </div>
                                <p className="search-result-content pt-4">No Records found
                                            </p>
                            </section>)}

                    </div>
                </div>
                <div className="modal p-0" id="add-fav-popup">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Add New Favorites</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row mt-3">
                                    <div className="col-12 edit-desc-field mb-4">
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Supplier Part#</Trans></label>
                                            <div className="col-md-7 input-group">
                                                <input type="text" className="form-control" placeholder="Enter ID" id="NewItemId" value={this.state.NewItemid} onKeyDown={this.keyPress} onBlur={this.handleSTrTxt} />
                                                <div className="input-group-append">
                                                    <span className="input-group-text" onClick={this.NewItemClick}>
                                                        <span className="shopping-search-icon" />
                                                    </span>
                                                </div>
                                            </div>

                                        </div>

                                        {this.bindNewFavItemDetail()}
                                        <div className="col-md-12 text-center mb-2" id="savebuttonid">
                                            {/*<button className="btn btn-secondary custom-btn-secondary secondary-btn px-4">Close</button>*/}
                                            {/*  {$("#NewItemId").val() == "" ? null :*/}
                                            {this.state.NewItem ?
                                                <button className="btn btn-primary custom-btn-primary primary-btn" onClick={this.InsertFavItem}><Trans>Save</Trans></button> : null}
                                        </div>
                                    </div>






                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" id="Cancel-confirmation">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            {/* 5731 - updated a modal title 4/28/2025 Nachiappan  */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-2">Remove Items</h4>
                               <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-2">
                                        <span className="question-mark-icon delete-confirm-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Do you want to remove this item?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={this.ConfirmationNO}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={this.state.multiDelete ? this.DeleteMultipleItem : this.ConfirmationYES}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="AltItems" data-backdrop="static" data-keyboard="false">
                    <AlternatepartsComponent altDetails={this.state.AltItems} flagTable={this.state.FilteredFlagTable} closePopup={this.closePopup}  {...this.props} />
                </div>
                <div className="modal" id="add-fav-img">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Do you want to add Image for this item?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.updatFavItem(this.state.EditItem, false)} ><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.EditFav(this.state.EditValue, "Yes")} ><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="modal p-0" id="edit-fav-popup">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Edit Favorites</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            {this.EditFavItemBind()}
                        </div>
                    </div>
                </div>
                {/*Core Charge Pop Up*/}
                <div className="modal" id="CoreChargePopUpFav" data-backdrop="static" data-keyboard="false">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">More info</h4>
                                {this.state.IskitCoreDisplay == false ?
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}>
                                        X
              </button> : null}
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block"><Trans>The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.</Trans></label>
                                        <label className="confirm-content d-block"><Trans>By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!</Trans></label>
                                        {this.state.IskitCoreDisplay == true ?
                                            <label className="confirm-content d-block"><Trans>If you want to remove the item, you can remove it from the shoppingcart </Trans></label> : null}
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        {this.state.IskitCoreDisplay == false ?
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}><Trans>Cancel</Trans></button> : null}{/**Added SelectedItemForCheaper to addtocart (which throwed exception)(9/5/2022)-Aparna*/}
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => { this.CoreChargeProceedClick(e) }}><Trans>Proceed</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/**WAL-714*/}
                <div className="modal" id="Fav_Item_Sharing" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Share</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.Fav_Order_Share_Close()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body" >
                                <div className="row">
                                    <div className="col-md-12 float-left">
                                        <div className="col-md-12 col-lg-12 mb-3 float-left p-0">
                                            <label className="col-lg-12 col-md-12 float-left p-0 catalog-label form-label"><Trans>Region</Trans></label>
                                            <div className="col-lg-12 col-md-12 float-left p-0 col-12">

                                                <Select
                                                    className="DropDown-Font-Size"
                                                    options={this.state.RegionDD}
                                                    value={this.state.SelectedRegion}
                                                    onChange={e => this.HandleOnChange(e, "SelectedRegion")}
                                                    name="REG"
                                                    isClearable={true}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 float-left">
                                        <div className="col-md-12 col-lg-12 mb-3 float-left p-0">
                                            <label className="col-lg-12 col-md-12 float-left p-0 catalog-label form-label"><Trans>User</Trans></label>
                                            <div className="col-lg-12 col-md-12 float-left p-0 col-12">

                                                <MultiSelect
                                                    options={this.state.UserDD}
                                                    className="DropDown-Font-Size UserCSS w-100"
                                                    id="REG"
                                                    value={this.state.SelectedUser}
                                                    onChange={e => this.HandleOnChange(e, "SelectedUser")}
                                                    labelledBy={"Select"}
                                                />


                                                <span className="errorspan1 text-left" style={{ fontSize: '14px' }} id="usererror" />
                                            </div>
                                        </div>


                                    </div>
                                    {/*<div className="col-md-10 float-left my-5">
                                        <label className="float-left col-md-3 form-label catalog-label pl-0"><Trans>User</Trans></label>
                                        <div id="DD">
                                            <MultiSelect
                                                options={this.state.UserDD}
                                                className="w-100 DropDown-Font-Size"
                                                id="PC"
                                                value={this.state.SelectedUser}
                                                onChange={e => this.HandleOnChange(e, "SelectedUser")}
                                                labelledBy={"Select"}

                                            />
                                        </div>
                                    </div>*/}
                                </div>
                                <div className="col-md-12 text-center mb-2 mt-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3" onClick={() => this.ShareButtonClick()}><Trans>OK</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
                <div className="modal fade p-0" id="FavItemMixedOrderConfirmPopup" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Confirmation
                                    </h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                {this.state.cartConfirmationPopupTxt}
                            </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                    type="button"
                                    data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  >No</button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                    type="button">Yes</button>

                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}

            </React.Fragment>
        );


    }
}
export default withTranslation()(FavItemMainComponent);
